<template>
	<div style="width: 100%;height: 100%;"
		:style="{paddingBottom:equipment == 'phone' && type == 'design'?'80px':'0px'}">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div v-if="!goodsData && type == 'design'" style="padding: 10px;width: 100%;font-size: 16px;">请添加测试商品</div>
		<div v-if="equipment == 'pc' && goodsData" style="width: 100%;height: 100%;">
			<div style="display: flex;width: 100%;flex-shrink: 0;">
				<div style="display: flex;flex-direction: column;" :style="{
					width:layoutConfig.left.width + '%',
				}">


					<div class="left" :style="{width:'100%',justifyContent:layoutConfig.left.layout}"
						style="display: flex;flex-shrink: 0;width: 100%;">
						<div :style="{flexDirection:layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'?'row':'column'}"
							style="display: flex;width: 100%;">
							<div :style="{
								 maxWidth:item == '1'?layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'?'fit-content':'550px':'100%'
							 }" :key="index" style="width: 100%;"
								v-for="(item,index) in  layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'top'?sort:sort1">
								<div v-if="item == '1'" style="display: flex;max-width: 700px;overflow-y: scroll;"
									:style="{padding:layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'?'0 3px':'2px 6px' ,flexDirection:layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'?'column':'row', height:layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'?550 + 'px':'none',width:layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'?'fit-content':'700px'}">
									<PreciseDragScroll
										v-if="layoutConfig.left.preViewListPosition != 'left' && layoutConfig.left.preViewListPosition != 'right'">
										<div @mouseenter.stop.prevent="selectImg = imgItem.preview;selectImgId = imgItem.preview + imgIndex"
											v-for="(imgItem,imgIndex) in goodsData.product.images" :key="imgIndex"
											:style="{marginTop:layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'?'0px':'0px',marginLeft:layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'?'0px':'0px',width:layoutConfig.left.preViewListImgWidth + 'px'}">
											<img :src="imgItem.preview"
												:style="{objectFit:getAffiliateBbjectFit(),border:selectImg == imgItem.preview?'solid 1px ' + layoutConfig.left.borderAffiliatedHoverColor:'none',...getAffiliatedBorder(imgItem,imgIndex),...getAffiliatedBoderRadius(),width:(layoutConfig.left.preViewListImgWidth - 3) + 'px',height:(layoutConfig.left.preViewListImgHeight - 3) + 'px'}"
												style="" />
										</div>
									</PreciseDragScroll>
									<div v-if="layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'"
										@mouseenter.stop.prevent="selectImg = imgItem.preview;selectImgId = imgItem.preview + imgIndex"
										v-for="(imgItem,imgIndex) in goodsData.product.images" :key="imgIndex"
										style="width: fit-content;"
										:style="{marginTop:layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'?'7px':'0px',marginLeft:layoutConfig.left.preViewListPosition == 'left' || layoutConfig.left.preViewListPosition == 'right'?'0px':'7px',height:layoutConfig.left.preViewListImgHeight + 'px'}">
										<img :src="imgItem.preview"
											:style="{objectFit:getAffiliateBbjectFit(),border:selectImg == imgItem.preview?'solid 1px '  + layoutConfig.left.borderAffiliatedHoverColor:'none',width:(layoutConfig.left.preViewListImgWidth - 3) + 'px',height:(layoutConfig.left.preViewListImgHeight - 3) + 'px',...getAffiliatedBorder(imgItem,imgIndex),...getAffiliatedBoderRadius()}" />
									</div>
								</div>
								<div v-if="item == '2'" :style="{
								}" style="max-width: 100%;display: flex;align-items: center;justify-content: center;overflow: hidden;">

									<div v-if="goodsData.product.video != '' && videoPlay" class="child"
										style="box-sizing: content-box;position: relative;display: flex;align-items: center;justify-content: center;background-color: #cfd1cf;max-width: 100%;"
										:style="{
										zIndex:1000,
										aspectRatio: `${layoutConfig.left.preViewImgWidth} / ${layoutConfig.left.preViewImgHeight}`,
										maxHeight:getObjectFit() == 'cover'?getMaxHeight():getMaxHeight(), objectFit:getObjectFit(),maxWidth: getMainImgMaxWidth(),...imageStyle,...getBorder(),...getBoderRadius()}">
										<video id="myVideo" :style="{
											 width:layoutConfig.left.percentWidthSwitch?getMainImgWidth('fill'):getMainImgWidth('noFill'),
										 }" style="height: 100%;max-width: 100%;" muted :playsinline="true" :webkit-playsinline="true" controls>
											<source :src="goodsData.product.video" type="video/mp4">
										</video>
										<div @click="videoPlay = false"
											style="position: absolute;z-index: 100;right: 10px;top: 10px;">
											<i style="font-size: 28px;color: #ffffff;cursor: pointer;"
												class="el-icon-circle-close"></i>
										</div>
									</div>
									<div @click="playVideo"
										v-if="goodsData.product.video != '' && !videoPlay && isMp4(goodsData.product.video)"
										style="position: absolute;width: 42px;height: 42px;z-index: 1000;border-radius: 100%;border: solid 6px #fff;display: flex;align-items: center;justify-content: center;">
										<i style="font-size: 28px;color: #ffffff;cursor: pointer;"
											class="el-icon-caret-right"></i>
									</div>

									<img v-if="!videoPlay" style="width: 100%;box-sizing: content-box;" class="child"
										@mouseenter.stop.prevent="handleMouseEnter"
										@mouseleave.stop.prevent="handleMouseLeave" :src="selectImg"
										:style="{
											width:layoutConfig.left.percentWidthSwitch?getMainImgWidth('fill'):getMainImgWidth('noFill'),
											aspectRatio: `${layoutConfig.left.preViewImgWidth} / ${layoutConfig.left.preViewImgHeight}`,
											maxHeight:getObjectFit() == 'cover'?getMaxHeight():getMaxHeight(), objectFit:getObjectFit(),maxWidth: getMainImgMaxWidth(),...imageStyle,...getBorder(),...getBoderRadius()}" />

								</div>
								<!-- <div class="parent" v-if="item == '2'"
									style="margin: 7px; max-height: 600px;overflow: hidden;margin: auto;"
									:style="{...getBoderRadius(),
									
									aspectRatio: `${layoutConfig.left.preViewImgWidth} / ${layoutConfig.left.preViewImgHeight}`
									}">
									<img style="width: 100%;" class="child" @mouseenter.stop.prevent="handleMouseEnter"
										@mouseleave.stop.prevent="handleMouseLeave" :src="selectImg"
										:style="{maxHeight:getObjectFit() == 'cover'?getMaxHeight():getMaxHeight(), objectFit:getObjectFit(),maxWidth: getMainImgMaxWidth(),height:layoutConfig.left.preViewImgHeight + 'px',...imageStyle,...getBorder(),...getBoderRadius()}" />
								</div> -->
							</div>
						</div>
					</div>

					<div style="width: 100%;margin-top: 20px;">
						<div v-if="layoutConfig.right.detailModel == 'label'  && layoutConfig.right.titSet.position == '2'"
							:style="{}">
							<div :style="{
									...getBgBtoTit(layoutConfig.right.titSet)
								}" style="display: flex;justify-content: center;cursor: pointer;margin-top: 10px;font-size: 16px;padding: 5px 0px;">
								<div style="" v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort"
									:key="sortIndex">
									<div v-if="layoutConfig.right.showDetail && sortItem.value == 'detail'"
										@click="tab = 'detail'" style=""
										:style="{
											marginLeft:layoutConfig.right.detailMl + 'px',
											marginRight:layoutConfig.right.detailMl + 'px',
											color:tab == 'detail'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}">
										{{$t('h.productDetail')}}
									</div>
									<div v-if="layoutConfig.right.showAttr && sortItem.value == 'attr'"
										@click="tab = 'size'"
										:style="{
											marginLeft:layoutConfig.right.detailMl + 'px',
											marginRight:layoutConfig.right.detailMl + 'px',
											color:tab == 'size'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
										style="margin-left: 5px;cursor: pointer;">
										{{$t('h.attribute')}}
									</div>
									<div v-if="layoutConfig.right.showComment && sortItem.value == 'coment'"
										@click="tab = 'comment';"
										:style="{
											marginLeft:layoutConfig.right.detailMl + 'px',
											marginRight:layoutConfig.right.detailMl + 'px',
											color:tab == 'comment'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize  + 'px'}"
										style="margin-left: 5px;cursor: pointer;margin-right: 5px;">
										{{$t('h.commentTit')}}
									</div>
								</div>
							</div>

							<div style="margin-top: 10px;" :style="{...getDetailBorder()}">
								<div v-if="layoutConfig.right.detailModel == 'label'"
									style="margin-top: 20px;margin: auto;overflow: hidden;"
									:style="{width:layoutConfig.bto.widthType == 'px'?layoutConfig.bto.width + 'px':'100%'}">
									<div style="width: 100%;" :style="getBgStyle(layoutConfig.bto)">
										<div style="display: flex;justify-content: center;">
											<div v-if="tab == 'detail' && goodsData.product.description"
												class="ql-container ql-snow" style="border:none;">
												<div class="ql-editor" style="width: fit-content;border:none; ">
													<div :style="{
														color:layoutConfig.right.tabColor.titColor
													}" v-html="goodsData.product.description">
														{{goodsData.product.description}}}
													</div>
												</div>
											</div>
											<div v-if="tab == 'size'" style="width: 100%;font-size: 14px;">
												<div style="width: 100%"
													v-for="(item,index) in goodsData.product.attributes" :key="index">
													<div style="border: solid 1px #c6c7c8;">
														<div :style="{
															 color:layoutConfig.right.tabColor.titColor
														 }" style="padding: 6px;">
															{{item.attribute_group_name}}
														</div>
													</div>
													<div style="width: 100%;"
														v-for="(attrItem,attrIndex) in item.attributes">
														<div
															style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
															<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
																{{attrItem.attribute}}
															</div>
															<div :style="{
															 	color:layoutConfig.right.tabColor.titColor
															 }" style="padding-left: 20px;padding: 6px;">
																{{attrItem.attribute_value}}
															</div>
														</div>
													</div>
												</div>
											</div>

											<div v-loading="commentCommentsLoad" style="width: 100%;min-height: 60px;"
												v-if="tab == 'comment'">
												<div :style="{
												 	color:layoutConfig.right.tabColor.titColor
													
												 }" style="margin: 20px;" v-if="goodsData.lcomment == 1" v-loading="loadingComment">
													<div v-for="(item,index) in evaluationForm" :key="index">
														<el-form :style="{
															'--formLabelColor':layoutConfig.right.tabColor.titColor
														}" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
															class="demo-ruleForm">
															<el-form-item :label="$t('h.author')"
																prop="comment_user_name">
																<el-input show-word-limit :maxlength="50"
																	:placeholder="$t('h.peleaseIpt')" :rows="1"
																	v-model="item.comment_user_name"></el-input>
															</el-form-item>

															<el-form-item :label="$t('h.comment')" prop="content_text">
																<el-input show-word-limit :maxlength="350"
																	:placeholder="$t('h.peleaseIpt')" :rows="3"
																	type="textarea"
																	v-model="item.content_text"></el-input>
															</el-form-item>
															<el-form-item v-if="goodsData.content_type == 2"
																style="width: 42%;" :label="$t('h.img')">
																<van-uploader max-count="5" :preview-full-image="false"
																	@delete="
																	(file,fileIndex)=>{
																		deleteImgEvaluation(file,fileIndex,item)
																	}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
																		afterReadEvaluation(file, fileItem,item)
																	}" />
															</el-form-item>
															<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
																<van-rate color="#ffaa00" touchable
																	v-model="item.score" />
															</el-form-item>
														</el-form>
													</div>

													<div v-if="goodsData.lcomment == 1"
														style="display: flex;align-items: center;">
														<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
															size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
														<el-button class="btn"
															style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
															size="mini"
															@click="upComments()">{{$t('h.confirm')}}</el-button>
													</div>
												</div>


												<el-empty v-if="commentdata && commentdata.length == 0"
													:description="$t('h.noContent')"></el-empty>
												<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
													style="width: 100%;display: flex;align-items: center;justify-content: center;">
													<el-button
														style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
														size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
												</div> -->
												<div v-if="commentdata " style="width: 100%;">
													<div v-for="(item,index) in commentdata" :key="index"
														style="width: 100%;">

														<div style="display: flex;width: 100%;align-items: center;">
															<div
																style="display: flex;flex-direction: column;align-items: center;margin-left: 20px;justify-content: center;width: 120px;">
																<div v-if="item.avatar"
																	style="width: 40px;height: 40px;border-radius: 100%;">
																	<img v-if="item.avatar" :src="item.avatar"
																		style="width: 40px;height: 40px;border-radius: 100%;" />
																</div>
																<div :style="{
																	color:layoutConfig.right.tabColor.titColor
																}" style="font-size: 14px;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
																	{{item.user_name}}
																</div>
															</div>
															<div
																style="margin-left: 20px;max-width: calc(100% - 120px);">
																<div :style="{
																		color:layoutConfig.right.tabColor.titColor
																	}" style="margin-top: 10px;font-size: 14px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
																	<div>{{item.content}}</div>
																</div>
																<div style="margin-top: 10px;">
																	<el-image v-for="(imgItem,imgIndex) in item.imgs"
																		:key="imgIndex"
																		style="width: 100px; height: 100px"
																		:src="imgItem" :preview-src-list="item.imgs">
																	</el-image>
																</div>
																<div style="margin-top: 10px
																;"><van-rate color="#ffaa00" touchable v-model="item.score" /></div>
																<div :style="{
																 	color:layoutConfig.right.tabColor.titColor
																 }" style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
																	<div>{{item.created_at}}</div>
																</div>
															</div>
														</div>
														<div
															style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
														</div>
													</div>

													<div v-if="commentdata && commentdata.length > 0"
														style="width: 100%;display: flex;justify-content: center;">
														<div style="display: flex;align-items: center;">
															<el-pagination :style="{
																'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
																'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
															}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}"
																style="margin: 10px;" layout="prev, pager, next"
																:total="contentTotal">
															</el-pagination>
															<div :style="{
																color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
															}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div style="margin-top: 15px;padding-bottom: 1px;"
						v-if="layoutConfig.right.detailModel == 'accordion'  && layoutConfig.right.titSet.position == '2'"
						:style="{...getDetailBorder(),...getBgStyle(layoutConfig.bto)}">
						<el-collapse :style="{
							'--bgColor':layoutConfig.bto.singleBgColor?layoutConfig.bto.singleBgColor :'#fff',
							'--fontColor':layoutConfig.right.tabColor.titColor?layoutConfig.right.tabColor.titColor:'#000',
							'--collapseFontSize':layoutConfig.right.tabFontSize + 'px'
						}" v-model="tabShow" accordion>
							<div style="width:100%" v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort"
								:key="sortIndex">
								<el-collapse-item v-show="layoutConfig.right.showDetail && sortItem.value == 'detail'"
									:title="$t('h.productDetail')" name="detail">
									<div class="ql-container ql-snow" style="border:none;">
										<div class="ql-editor" style="width: fit-content;border:none; ">
											<div v-html="goodsData.product.description">
												{{goodsData.product.description}}}
											</div>
										</div>
									</div>
								</el-collapse-item>
								<el-collapse-item v-show="layoutConfig.right.showAttr && sortItem.value == 'attr'"
									:title="$t('h.attribute')" name="size">
									<div style="width: 100%;font-size: 14px;">
										<div style="width: 100%" v-for="(item,index) in goodsData.product.attributes"
											:key="index">
											<div style="border: solid 1px #c6c7c8;">
												<div :style="{
													 	color:layoutConfig.right.tabColor.titColor
													 }" style="padding: 6px;">
													{{item.attribute_group_name}}
												</div>
											</div>
											<div style="width: 100%;" v-for="(attrItem,attrIndex) in item.attributes">
												<div
													style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
													<div :style="{
														 	color:layoutConfig.right.tabColor.titColor
														 }" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
														{{attrItem.attribute}}
													</div>
													<div :style="{
														 	color:layoutConfig.right.tabColor.titColor
														 }" style="padding-left: 20px;padding: 6px;">
														{{attrItem.attribute_value}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</el-collapse-item>


								<el-collapse-item style="border-bottom: solid 1px #cccccc;"
									v-show="layoutConfig.right.showComment && sortItem.value == 'coment'"
									:title="$t('h.commentTit')" name="comment">
									<div v-loading="commentCommentsLoad" style="width: 100%;min-height: 60px;">

										<div style="margin: 0px 20px;" v-if="goodsData.lcomment == 1"
											v-loading="loadingComment">
											<div v-for="(item,index) in evaluationForm" :key="index">
												<el-form :style="{
													 	'--formLabelColor':layoutConfig.right.tabColor.titColor
													 }" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
													class="demo-ruleForm">
													<el-form-item :label="$t('h.author')" prop="comment_user_name">
														<el-input show-word-limit :maxlength="50"
															:placeholder="$t('h.peleaseIpt')" :rows="1"
															v-model="item.comment_user_name"></el-input>
													</el-form-item>

													<el-form-item :label="$t('h.comment')" prop="content_text">
														<el-input show-word-limit :maxlength="350"
															:placeholder="$t('h.peleaseIpt')" :rows="3" type="textarea"
															v-model="item.content_text"></el-input>
													</el-form-item>
													<el-form-item v-if="goodsData.content_type == 2" style="width: 42%;"
														:label="$t('h.img')">
														<van-uploader max-count="5" :preview-full-image="false" @delete="
																(file,fileIndex)=>{
																	deleteImgEvaluation(file,fileIndex,item)
																}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
																	afterReadEvaluation(file, fileItem,item)
																}" />
													</el-form-item>
													<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
														<van-rate color="#ffaa00" touchable v-model="item.score" />
													</el-form-item>
												</el-form>
											</div>

											<div style="display: flex;align-items: center;">
												<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
														size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
												<el-button class="btn"
													style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
													size="mini" @click="upComments()">{{$t('h.confirm')}}</el-button>
											</div>
										</div>

										<el-empty v-if="commentdata && commentdata.length == 0"
											:description="$t('h.noContent')"></el-empty>
										<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
												style="width: 100%;display: flex;align-items: center;justify-content: center;">
												<el-button
													style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
													size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
											</div> -->
										<div v-if="commentdata " style="width: 100%;">
											<div v-for="(item,index) in commentdata" :key="index" style="width: 100%;">

												<div style="display: flex;width: 100%;align-items: center;">
													<div
														style="display: flex;flex-direction: column;align-items: center;width: 120px;margin-left: 20px;">
														<div style="width: 40px;height: 40px;border-radius: 100%;">
															<img v-if="item.avatar" :src="item.avatar"
																style="width: 40px;height: 40px;border-radius: 100%;" />
														</div>
														<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}" style="font-size: 14px;color: #9fa19f;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
															{{item.user_name}}
														</div>
													</div>
													<div style="margin-left: 20px;width: calc(100% - 120px);">
														<div
															style="margin-top: 10px;font-size: 14px;color: #9fa19f;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
															<div :style="{
																	color:layoutConfig.right.tabColor.titColor
																}">{{item.content}}</div>
														</div>
														<div style="margin-top: 10px;">
															<el-image v-for="(imgItem,imgIndex) in item.imgs"
																:key="imgIndex" style="width: 100px; height: 100px"
																:src="imgItem" :preview-src-list="item.imgs">
															</el-image>
														</div>
														<div style="margin-top: 10px
															;"><van-rate color="#ffaa00" touchable v-model="item.score" /></div>
														<div style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
															<div :style="{
																	color:layoutConfig.right.tabColor.titColor
																}">{{item.created_at}}</div>
														</div>
													</div>
												</div>
												<div
													style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
												</div>
											</div>

											<div v-if="commentdata && commentdata.length > 0"
												style="width: 100%;display: flex;justify-content: center;">
												<div style="display: flex;align-items: center;">
													<el-pagination :style="{
															'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
															'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
														}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}" style="margin: 10px;"
														layout="prev, pager, next" :total="contentTotal">
													</el-pagination>
													<div :style="{
															color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
														}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
												</div>
											</div>
										</div>
									</div>
								</el-collapse-item>
							</div>
						</el-collapse>
					</div>

					<div v-if="layoutConfig.right.detailModel == 'block' && layoutConfig.right.titSet.position == '2'"
						style="margin-top: 20px;">
						<div v-if="layoutConfig.right.detailModel == 'block'" :style="{...getDetailBorder()}">
							<div v-if="layoutConfig.right.detailModel == 'block'" style="margin-top: 20px;margin: auto;"
								:style="{width:layoutConfig.bto.widthType == 'px'?layoutConfig.bto.width + 'px':'100%'}">
								<div style="width: 100%;" :style="getBgStyle(layoutConfig.bto)">
									<div style="display: flex;justify-content: center;flex-direction: column;">
										<div v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort"
											:key="sortIndex">
											<div style="margin-left: 10px;margin-top: 10px;"
												v-if="layoutConfig.right.showDetail && sortItem.value == 'detail'"
												:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}">
												{{$t('h.productDetail')}}
											</div>
											<div v-if="goodsData.product.description && layoutConfig.right.showDetail && sortItem.value == 'detail'"
												class="ql-container ql-snow" style="border:none;">
												<div class="ql-editor" style="width: fit-content;border:none; ">
													<div :style="{
													 	color:layoutConfig.right.tabColor.titColor
													 }" v-html="goodsData.product.description">{{goodsData.product.description}}}
													</div>
												</div>
											</div>
											<div v-if="layoutConfig.right.showAttr && sortItem.value == 'attr'"
												:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
												style="margin-left: 10px;cursor: pointer;margin-top: 10px;">
												{{$t('h.attribute')}}
											</div>
											<div v-if="layoutConfig.right.showAttr  && sortItem.value == 'attr'"
												style="width: 100%;font-size: 14px;margin-top: 20px;">
												<div style="width: 100%"
													v-for="(item,index) in goodsData.product.attributes" :key="index">
													<div style="border: solid 1px #c6c7c8;">
														<div :style="{
														 	color:layoutConfig.right.tabColor.titColor
														 }" style="padding: 6px;">
															{{item.attribute_group_name}}
														</div>
													</div>
													<div style="width: 100%;"
														v-for="(attrItem,attrIndex) in item.attributes">
														<div
															style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
															<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
																<!-- <img style="position: absolute;top: 0;left: 0;width: 100%;"
																	class="child" @mouseenter.stop.prevent="handleMouseEnter"
																	@mouseleave.stop.prevent="handleMouseLeave" :src="selectImg"
																	:style="{maxHeight:getObjectFit() == 'cover'?getMaxHeight():getMaxHeight(), objectFit:getObjectFit(),maxWidth: getMainImgMaxWidth(),width:layoutConfig.left.percentWidthSwitch?getMainImgWidth('fill'):getMainImgWidth('noFill'),height:layoutConfig.left.preViewImgHeight + 'px',...imageStyle,...getBorder(),...getBoderRadius()}" /> -->
																{{attrItem.attribute}}
															</div>
															<div :style="{
															 	color:layoutConfig.right.tabColor.titColor
															 }" style="padding-left: 20px;padding: 6px;">
																{{attrItem.attribute_value}}
															</div>
														</div>
													</div>
												</div>
											</div>
											<div v-if="layoutConfig.right.showComment  && sortItem.value == 'coment'"
												:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
												style="margin-left: 10px;cursor: pointer;margin-top: 10px;">
												{{$t('h.commentTit')}}
											</div>
											<div v-loading="commentCommentsLoad"
												style="width: 100%;min-height: 60px;margin-top: 20px;"
												v-if="layoutConfig.right.showComment && sortItem.value == 'coment'">
												<div style="margin: 20px;" v-if="goodsData.lcomment == 1"
													v-loading="loadingComment">
													<div v-for="(item,index) in evaluationForm" :key="index">
														<el-form :style="{
														  	'--formLabelColor':layoutConfig.right.tabColor.titColor
														  }" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
															class="demo-ruleForm">
															<el-form-item :label="$t('h.author')"
																prop="comment_user_name">
																<el-input show-word-limit :maxlength="50"
																	:placeholder="$t('h.peleaseIpt')" :rows="1"
																	v-model="item.comment_user_name"></el-input>
															</el-form-item>

															<el-form-item :label="$t('h.comment')" prop="content_text">
																<el-input show-word-limit :maxlength="350"
																	:placeholder="$t('h.peleaseIpt')" :rows="3"
																	type="textarea"
																	v-model="item.content_text"></el-input>
															</el-form-item>
															<el-form-item v-if="goodsData.content_type == 2"
																style="width: 42%;" :label="$t('h.img')">
																<van-uploader max-count="5" :preview-full-image="false"
																	@delete="
																	(file,fileIndex)=>{
																		deleteImgEvaluation(file,fileIndex,item)
																	}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
																		afterReadEvaluation(file, fileItem,item)
																	}" />
															</el-form-item>
															<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
																<van-rate color="#ffaa00" touchable
																	v-model="item.score" />
															</el-form-item>
														</el-form>
													</div>

													<div style="display: flex;align-items: center;">
														<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
															size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
														<el-button class="btn"
															style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
															size="mini"
															@click="upComments()">{{$t('h.confirm')}}</el-button>
													</div>
												</div>



												<el-empty v-if="commentdata && commentdata.length == 0"
													:description="$t('h.noContent')"></el-empty>
												<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
													style="width: 100%;display: flex;align-items: center;justify-content: center;">
													<el-button
														style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
														size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
												</div> -->
												<div v-if="commentdata " style="width: 100%;">
													<div v-for="(item,index) in commentdata" :key="index"
														style="width: 100%;">
														<div style="display: flex;width: 100%;align-items: center;">
															<div
																style="display: flex;flex-direction: column;align-items: center;width: 120px;margin-left: 20px;">
																<div v-if="item.avatar"
																	style="width: 40px;height: 40px;border-radius: 100%;">
																	<img v-if="item.avatar" :src="item.avatar"
																		style="width: 40px;height: 40px;border-radius: 100%;" />
																</div>
																<div :style="{
																	color:layoutConfig.right.tabColor.titColor
																}" style="font-size: 14px;color: #9fa19f;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
																	{{item.user_name}}
																</div>
															</div>
															<div
																style="margin-left: 20px;max-width: calc(100% - 120px);">
																<div
																	style="margin-top: 10px;font-size: 14px;color: #9fa19f;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
																	<div :style="{
																		color:layoutConfig.right.tabColor.titColor
																	}">{{item.content}}</div>
																</div>
																<div style="margin-top: 10px;">
																	<el-image v-for="(imgItem,imgIndex) in item.imgs"
																		:key="imgIndex"
																		style="width: 100px; height: 100px"
																		:src="imgItem" :preview-src-list="item.imgs">
																	</el-image>
																</div>
																<div style="margin-top: 10px;"><van-rate color="#ffaa00"
																		touchable v-model="item.score" /></div>
																<div
																	style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
																	<div :style="{
																		color:layoutConfig.right.tabColor.titColor
																	}">{{item.created_at}}</div>
																</div>
															</div>
														</div>
														<div
															style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
														</div>
													</div>
													<div v-if="commentdata && commentdata.length > 0"
														style="width: 100%;display: flex;justify-content: center;">
														<div style="display: flex;align-items: center;">
															<el-pagination :style="{
																'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
																'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
															}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}"
																style="margin: 10px;" layout="prev, pager, next"
																:total="contentTotal">
															</el-pagination>
															<div :style="{
																color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
															}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
														</div>
													</div>
												</div>
											</div>

										</div>

									</div>
								</div>
							</div>
						</div>
					</div>


				</div>
				<div class="right"
					:style="{width:layoutConfig.right.width + '%',paddingLeft:layoutConfig.right.marginLeft + 'px'}">
					<div class="title"
						style="width: 100%;word-wrap: break-word;overflow-wrap: break-word;white-space: normal;"
						:style="{fontSize:layoutConfig.right.titleSize + 'px',color:layoutConfig.right.titleColor,fontWeight:layoutConfig.right.titleBold,fontFamily:layoutConfig.right.titleFontFamily}">
						{{goodsData.product.name}}
					</div>
					<div v-if="layoutConfig.right.priceShow.price || layoutConfig.right.priceShow.originalPrice"
						class="title" style="display: flex;align-items: center;margin-top: 20px;">
						<div style="margin-right: 20px; " v-if="layoutConfig.right.priceShow.price"
							:style="{fontSize:layoutConfig.right.priceSize + 'px',color:layoutConfig.right.priceColor,fontWeight:layoutConfig.right.priceBold,fontFamily:layoutConfig.right.priceFontFamily}">
							{{sku.price_format}}
						</div>
						<div v-if="layoutConfig.right.priceShow.originalPrice"
							:style="{fontSize:layoutConfig.right.discountSize + 'px',color:layoutConfig.right.discountColor,fontWeight:layoutConfig.right.discountBold,fontFamily:layoutConfig.right.discountFamily}"
							style="text-decoration: line-through;">
							{{sku.origin_price_format}}
						</div>
					</div>
					<div v-if="layoutConfig.right.showInventory" class="title"
						style="display: flex;align-items: center;margin-top: 30px;">
						<div
							:style="{fontSize:layoutConfig.right.quantityFont.fontSize + 'px',color:layoutConfig.right.quantityFont.color}">
							{{$t('h.quantity')}}
						</div>
						<div :style="{fontSize:layoutConfig.right.quantityFont.titFontSize + 'px',
						 color:layoutConfig.right.quantityFont.titColor
						 }" style="margin-left: 10px;">
							{{sku.quantity > 0?$t('h.quantityExits'):$t('h.quantityNone')}}
						</div>
					</div>
					<div v-if="layoutConfig.right.showBrand" :style="{fontSize:layoutConfig.right.brandSize + 'px'}"
						class="title" style="display: flex;align-items: center;margin-top: 10px;">
						<div :style="{fontSize:layoutConfig.right.brandFont.fontSize + 'px',
						  color:layoutConfig.right.brandFont.color
						  }" style="color: #9fa19f ;">
							{{$t('h.brand')}}:
						</div>
						<div :style="{fontSize:layoutConfig.right.brandFont.titFontSize + 'px',
						  color:layoutConfig.right.brandFont.titColor
						  }" style="margin-left: 10px;">
							{{goodsData.product.brand_name}}
						</div>
					</div>
					<div v-if="layoutConfig.right.showSKU" :style="{fontSize:layoutConfig.right.skuSize + 'px'}"
						class="title" style="display: flex;align-items: center;margin-top: 10px;">
						<div :style="{fontSize:layoutConfig.right.skuFont.fontSize + 'px',
						  color:layoutConfig.right.skuFont.color
						  }" style="color: #9fa19f ;">
							{{$t('h.sku')}}:
						</div>
						<div :style="{fontSize:layoutConfig.right.skuFont.titFontSize + 'px',
						  color:layoutConfig.right.skuFont.titColor
						  }" style="margin-left: 10px;">
							{{sku.sku}}
						</div>
					</div>
					<div v-if="layoutConfig.right.showSize" :style="{fontSize:layoutConfig.right.sSize + 'px'}"
						class="title" style="display: flex;align-items: center;margin-top: 10px;">
						<div :style="{fontSize:layoutConfig.right.modelFont.fontSize + 'px',
						  color:layoutConfig.right.modelFont.color
						  }" style="color: #9fa19f ;">
							{{$t('h.model')}}:
						</div>
						<div :style="{fontSize:layoutConfig.right.modelFont.titFontSize + 'px',
						  color:layoutConfig.right.modelFont.titColor
						  }" style="margin-left: 10px;">
							{{sku.model}}
						</div>
					</div>
					<div style="margin-top: 15px;">
						<div :style="{fontSize:layoutConfig.right.specSize + 'px'}"
							v-for="(item,index) in goodsData.product.variables" :key="index">
							<div :style="{
									color:layoutConfig.right.optionColor,fontSize:layoutConfig.right.optionSize + 'px',fontFamily:layoutConfig.right.optionFamily?layoutConfig.right.optionFamily:selectdItem.preStyle.font.fontFamily
									}">
								{{item.name}}
							</div>
							<div style="width:fit-content;display: flex;align-items: center;flex-wrap: wrap;">
								<div @mouseenter.stop.prevent="enterSizeItem = value"
									@mouseleave.stop.prevent="enterSizeItem = null"
									@click.stop.prevent="selectValue(item,value,valueIndex,index)"
									:style="{
										padding:layoutConfig.right.showSelectImg?value.image?'0px':'4px':'4px',
										...getSelectTabBgColor(select,item,index,value),fontSize:layoutConfig.right.optionSize + 'px',color:getSelectTabColor(select,item,index,value),...getBorderSize(item,value,index),fontFamily:layoutConfig.right.optionFamily?layoutConfig.right.optionFamily:selectdItem.preStyle.font.fontFamily,...getBorderRadius(item,value)}"
									style="min-width: 50px;display: flex;align-items: center;justify-content: center;margin: 5px;cursor: pointer;"
									v-for="(value,valueIndex) in item.values" :key="valueIndex">


									<div v-if="layoutConfig.right.showSelectImg?value.image?false:true:true">
										{{value.name}}
									</div>
									<div :style="{
										 height:equipment != 'phone'? layoutConfig.right.showSelectImgSet.height + 'px' : layoutConfig.right.showSelectImgSet.phoneHeight + 'px',
										 width:equipment != 'phone'? layoutConfig.right.showSelectImgSet.width + 'px' : layoutConfig.right.showSelectImgSet.phoneWidth + 'px'
									 }" v-if="layoutConfig.right.showSelectImg?value.image?true:false:false">
										<img :style="{
											
											...getBorderRadius(item,value),
											objectFit:layoutConfig.right.showSelectImgSet.mode,
										}" :src="value.image" style="width: 100%;height: 100%;">
									</div>
									<!-- {{value.name}} -->
								</div>
							</div>
						</div>
						<div v-if="goodsData.product.options && goodsData.product.options.length > 0">

							<div  :style="{fontSize:layoutConfig.right.specSize + 'px',marginTop:index!=0?'5px':'0px',}"
								v-for="(item,index) in goodsData.product.options" :key="index">
								<div :style="{
									color:layoutConfig.right.optionColor,fontSize:layoutConfig.right.optionSize + 'px',fontFamily:layoutConfig.right.optionFamily?layoutConfig.right.optionFamily:selectdItem.preStyle.font.fontFamily
									}">
									{{item.option_name}} <span style="margin-left: 4px;" v-if="getAddOstionPrice(item) != '0.00'">( + {{getAddOstionPrice(item)}} )</span>
								</div>
								<div style="width:fit-content;display: flex;align-items: flex-start;flex-wrap: wrap;margin-top:5px">
									<div @mouseenter.stop.prevent="enterSizeItem = {item,index,value,valueIndex}"
										@mouseleave.stop.prevent="enterSizeItem = null"
										@click="changeOptionsSelect(item,index,value,valueIndex)"
										:style="{
											...!value.ciopimage?getSelectTabBgColorCustomize(select,item,index,value,valueIndex):{},
											...!value.ciopimage?getBorderSizeCustomize(item,index,value,valueIndex):{},
											fontSize:layoutConfig.right.optionSize + 'px',
											fontFamily:layoutConfig.right.optionFamily?layoutConfig.right.optionFamily:selectdItem.preStyle.font.fontFamily,
											...getBorderRadiusCustomize(item,index,value,valueIndex),
											color:getSelectTabColorCustomize(select,item,index,value,valueIndex),fontSize:layoutConfig.right.optionSize + 'px'}"
										style="min-width: 50px;display: flex;align-items: center;justify-content: center;margin: 5px;cursor: pointer;padding: 4px;flex-direction: column;"
										v-for="(value,valueIndex) in item.values" :key="valueIndex">
										
										<!-- ...getSelectTabBgColorCustomize(select,item,index,value,valueIndex), -->
										<div :style="{
											...value.ciopimage?getBorderSizeCustomize(item,index,value,valueIndex):{},
											 height:equipment != 'phone'? layoutConfig.right.showSelectImgSet.height + 'px' : layoutConfig.right.showSelectImgSet.phoneHeight + 'px',
											 width:equipment != 'phone'? layoutConfig.right.showSelectImgSet.width + 'px' : layoutConfig.right.showSelectImgSet.phoneWidth + 'px'
										 }" v-if="value.ciopimage">
											<img :style="{
												...getBorderRadiusCustomize(item,index,value,valueIndex),
												objectFit:layoutConfig.right.showSelectImgSet.mode,
											}" :src="value.ciopimage" style="width: 100%;height: 100%;">
										</div>
										
										<div :style="{
											 width:equipment != 'phone'? layoutConfig.right.showSelectImgSet.width + 'px' : layoutConfig.right.showSelectImgSet.phoneWidth + 'px'
										}" style="margin-top:4px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;text-align:center">
											{{value.value_name}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<div v-if="goodsData.product.options && goodsData.product.options.length > 0" style="margin-top: 10px;font-weight: bold;" :style="{fontSize:layoutConfig.right.priceSize + 'px',color:layoutConfig.right.priceColor,fontWeight:layoutConfig.right.priceBold,fontFamily:layoutConfig.right.priceFontFamily}">
						<div>{{$t('h.customizationFee')}} + {{ sku.price_format.substring(0, 1)}}{{getAddOstionPriceAll()}}</div>
						<div style="margin-top: 6px;">{{$t('h.priceTotal')}} {{ sku.price_format.substring(0, 1)}}{{sku.price + getAddOstionPriceAll()}} </div>
					</div>
					<div class="bto" style="display: flex;align-items: center;font-size: 16px;flex-wrap: wrap;">
						<van-stepper v-if="layoutConfig.right.showAddNum" button-size="40px" input-width="50px" :style="{
								width:layoutConfig.right.rightBtn.addNumFull? '100%' : 'fit-content'
							}" style="margin-right: 15px;background-color: #fff;width: 100%;margin-top: 20px;" v-model="order.num" min="1"
							max="800000000000000000000000000000" />
						<div v-if="layoutConfig.right.rightBtn" :style="{
						 	minWidth:layoutConfig.right.rightBtn.addCartFull? '100%' : layoutConfig.right.rightBtn.addCartWidth + 'px'
						 }" style="margin-top: 20px;margin-right: 15px;">
							<div v-if="layoutConfig.right.showAddCart" @click="addCarts" class="add-cart" :style="{
									width:layoutConfig.right.rightBtn.addCartWidth + 'px',
									border:`solid 1px ${layoutConfig.right.rightBtnColor.addCart.border.color}`,
									...getBtnBgColor(layoutConfig.right.rightBtnColor.addCart),
										color:layoutConfig.right.rightBtnColor.addCart.color
								}" style="max-width:100%;height: 34px;padding: 4px 0px;display: flex;align-items: center;justify-content: center;border-radius: 5px;font-weight: 400;cursor: pointer;">
								<i class="el-icon-shopping-cart-2" style="margin-top: 2px;"></i>
								<span style="margin-left: 2px;cursor: pointer;">
									{{$t('h.addCart')}}
								</span>
							</div>
						</div>
						<div :style="{
						 	minWidth:layoutConfig.right.rightBtn.buyNowFull? '100%' : layoutConfig.right.rightBtn.buyNowWidth + 'px'
						 }" style="margin-top: 20px;margin-right: 15px;">
							<div v-if="layoutConfig.right.showBuyNow" @click="buyNow" :style="{
									width:layoutConfig.right.rightBtn.buyNowWidth + 'px',
									border:`solid 1px ${layoutConfig.right.rightBtnColor.buyNow.border.color}`,
									...getBtnBgColor(layoutConfig.right.rightBtnColor.buyNow),
									color:layoutConfig.right.rightBtnColor.buyNow.color
								}" style="max-width:100%;cursor: pointer;height: 34px;padding: 4px 0px;display: flex;align-items: center;justify-content: center;border-radius: 5px;font-weight: 400;">
								<i class="el-icon-goods" style="margin-top: 2px;"></i>
								<span style="margin-left: 2px;">
									{{$t('h.buyNow')}}
								</span>
							</div>
						</div>
						<div :style="{
						 	minWidth:layoutConfig.right.rightBtn.loveFull? '100%' : 'fit-content'
						 }" style="margin-top: 20px;">
							<div v-if="layoutConfig.right.showLove" @click="collect"
								style="margin-left: 15px;font-size: 26px;cursor: pointer;">
								<i :style="{
								 	color:layoutConfig.right.rightBtnColor.love.bg.color
								 }" v-if="!isCollct" class="el-icon-star-off"></i>
								<i :style="{
									color:layoutConfig.right.rightBtnColor.love.bg.color
								}" v-if="isCollct" class="el-icon-star-on"></i>
							</div>
						</div>
					</div>

					<div style="width: 100%;margin-top: 20px;">
						<div v-if="layoutConfig.right.detailModel == 'label'  && layoutConfig.right.titSet.position == '3'"
							:style="{}">

							<div :style="{
									...getBgBtoTit(layoutConfig.right.titSet)
								}" style="display: flex;justify-content: center;cursor: pointer;margin-top: 10px;font-size: 16px;padding: 5px 0px;">
								<div style="" v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort"
									:key="sortIndex">
									<div v-if="layoutConfig.right.showDetail && sortItem.value == 'detail'"
										@click="tab = 'detail'" style="margin-right: 5px;margin-left: 5px;"
										:style="{
											marginLeft:layoutConfig.right.detailMl + 'px',
											marginRight:layoutConfig.right.detailMl + 'px',
											color:tab == 'detail'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}">
										{{$t('h.productDetail')}}
									</div>
									<div v-if="layoutConfig.right.showAttr && sortItem.value == 'attr'"
										@click="tab = 'size'"
										:style="{
											marginLeft:layoutConfig.right.detailMl + 'px',
											marginRight:layoutConfig.right.detailMl + 'px',
											color:tab == 'size'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
										style="margin-left: 5px;cursor: pointer;">
										{{$t('h.attribute')}}
									</div>
									<div v-if="layoutConfig.right.showComment && sortItem.value == 'coment'"
										@click="tab = 'comment';"
										:style="{
											marginLeft:layoutConfig.right.detailMl + 'px',
											marginRight:layoutConfig.right.detailMl + 'px',
											color:tab == 'comment'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
										style="margin-left: 5px;cursor: pointer;margin-right: 5px;">
										{{$t('h.commentTit')}}
									</div>
								</div>

							</div>


							<div style="margin-top: 10px;" :style="{...getDetailBorder()}">
								<div v-if="layoutConfig.right.detailModel == 'label'"
									style="margin-top: 20px;margin: auto;overflow: hidden;"
									:style="{width:layoutConfig.bto.widthType == 'px'?layoutConfig.bto.width + 'px':'100%'}">
									<div style="width: 100%;" :style="getBgStyle(layoutConfig.bto)">
										<div style="display: flex;justify-content: center;">
											<div v-if="tab == 'detail' && goodsData.product.description"
												class="ql-container ql-snow" style="border:none;">
												<div class="ql-editor" style="width: fit-content;border:none; ">
													<div :style="{
														color:layoutConfig.right.tabColor.titColor
													}" v-html="goodsData.product.description">
														{{goodsData.product.description}}}
													</div>
												</div>
											</div>
											<div v-if="tab == 'size'" style="width: 100%;font-size: 14px;">
												<div style="width: 100%"
													v-for="(item,index) in goodsData.product.attributes" :key="index">
													<div style="border: solid 1px #c6c7c8;">
														<div :style="{
															 color:layoutConfig.right.tabColor.titColor
														 }" style="padding: 6px;">
															{{item.attribute_group_name}}
														</div>
													</div>
													<div style="width: 100%;"
														v-for="(attrItem,attrIndex) in item.attributes">
														<div
															style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
															<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
																{{attrItem.attribute}}
															</div>
															<div :style="{
															 	color:layoutConfig.right.tabColor.titColor
															 }" style="padding-left: 20px;padding: 6px;">
																{{attrItem.attribute_value}}
															</div>
														</div>
													</div>
												</div>
											</div>

											<div v-loading="commentCommentsLoad" style="width: 100%;min-height: 60px;"
												v-if="tab == 'comment'">

												<div :style="{
												 	color:layoutConfig.right.tabColor.titColor
												 }" style="margin: 20px;" v-if="goodsData.lcomment == 1" v-loading="loadingComment">
													<div v-for="(item,index) in evaluationForm" :key="index">
														<el-form :style="{
															'--formLabelColor':layoutConfig.right.tabColor.titColor
														}" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
															class="demo-ruleForm">
															<el-form-item :label="$t('h.author')"
																prop="comment_user_name">
																<el-input show-word-limit :maxlength="50"
																	:placeholder="$t('h.peleaseIpt')" :rows="1"
																	v-model="item.comment_user_name"></el-input>
															</el-form-item>

															<el-form-item :label="$t('h.comment')" prop="content_text">
																<el-input show-word-limit :maxlength="350"
																	:placeholder="$t('h.peleaseIpt')" :rows="3"
																	type="textarea"
																	v-model="item.content_text"></el-input>
															</el-form-item>
															<el-form-item v-if="goodsData.content_type == 2"
																style="width: 42%;" :label="$t('h.img')">
																<van-uploader max-count="5" :preview-full-image="false"
																	@delete="
																	(file,fileIndex)=>{
																		deleteImgEvaluation(file,fileIndex,item)
																	}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
																		afterReadEvaluation(file, fileItem,item)
																	}" />
															</el-form-item>
															<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
																<van-rate color="#ffaa00" touchable
																	v-model="item.score" />
															</el-form-item>
														</el-form>
													</div>

													<div v-if="goodsData.lcomment == 1"
														style="display: flex;align-items: center;">
														<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
															size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
														<el-button class="btn"
															style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
															size="mini"
															@click="upComments()">{{$t('h.confirm')}}</el-button>
													</div>
												</div>


												<el-empty v-if="commentdata && commentdata.length == 0"
													:description="$t('h.noContent')"></el-empty>
												<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
													style="width: 100%;display: flex;align-items: center;justify-content: center;">
													<el-button
														style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
														size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
												</div> -->
												<div v-if="commentdata " style="width: 100%;">
													<div v-for="(item,index) in commentdata" :key="index"
														style="width: 100%;">

														<div style="display: flex;width: 100%;align-items: center;">
															<div
																style="display: flex;flex-direction: column;align-items: center;margin-left: 20px;justify-content: center;width: 120px;">
																<div v-if="item.avatar"
																	style="width: 40px;height: 40px;border-radius: 100%;">
																	<img v-if="item.avatar" :src="item.avatar"
																		style="width: 40px;height: 40px;border-radius: 100%;" />
																</div>
																<div :style="{
																	color:layoutConfig.right.tabColor.titColor
																}" style="font-size: 14px;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
																	{{item.user_name}}
																</div>
															</div>
															<div
																style="margin-left: 20px;max-width: calc(100% - 120px);">
																<div :style="{
																		color:layoutConfig.right.tabColor.titColor
																	}" style="margin-top: 10px;font-size: 14px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
																	<div>{{item.content}}</div>
																</div>
																<div style="margin-top: 10px;">
																	<el-image v-for="(imgItem,imgIndex) in item.imgs"
																		:key="imgIndex"
																		style="width: 100px; height: 100px"
																		:src="imgItem" :preview-src-list="item.imgs">
																	</el-image>
																</div>
																<div style="margin-top: 10px
																;"><van-rate color="#ffaa00" touchable v-model="item.score" /></div>
																<div :style="{
																 	color:layoutConfig.right.tabColor.titColor
																 }" style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
																	<div>{{item.created_at}}</div>
																</div>
															</div>
														</div>
														<div
															style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
														</div>
													</div>

													<div v-if="commentdata && commentdata.length > 0"
														style="width: 100%;display: flex;justify-content: center;">
														<div style="display: flex;align-items: center;">
															<el-pagination :style="{
																'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
																'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
															}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}"
																style="margin: 10px;" layout="prev, pager, next"
																:total="contentTotal">
															</el-pagination>
															<div :style="{
																color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
															}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div style="margin-top: 15px;padding-bottom: 1px;"
						v-if="layoutConfig.right.detailModel == 'accordion'  && layoutConfig.right.titSet.position == '3'"
						:style="{...getDetailBorder(),...getBgStyle(layoutConfig.bto)}">
						<el-collapse :style="{
							'--bgColor':layoutConfig.bto.singleBgColor?layoutConfig.bto.singleBgColor :'#fff',
							'--fontColor':layoutConfig.right.tabColor.titColor?layoutConfig.right.tabColor.titColor:'#000',
							'--collapseFontSize':layoutConfig.right.tabFontSize + 'px'
						}" v-model="tabShow" accordion>
							<div style="width:100%" v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort"
								:key="sortIndex">
								<el-collapse-item v-show="layoutConfig.right.showDetail && sortItem.value == 'detail'"
									:title="$t('h.productDetail')" name="detail">
									<div class="ql-container ql-snow" style="border:none;">
										<div class="ql-editor" style="width: fit-content;border:none; ">
											<div v-html="goodsData.product.description">
												{{goodsData.product.description}}}
											</div>
										</div>
									</div>
								</el-collapse-item>
								<el-collapse-item v-show="layoutConfig.right.showAttr && sortItem.value == 'attr'"
									:title="$t('h.attribute')" name="size">
									<div style="width: 100%;font-size: 14px;">
										<div style="width: 100%" v-for="(item,index) in goodsData.product.attributes"
											:key="index">
											<div style="border: solid 1px #c6c7c8;">
												<div :style="{
													 	color:layoutConfig.right.tabColor.titColor
													 }" style="padding: 6px;">
													{{item.attribute_group_name}}
												</div>
											</div>
											<div style="width: 100%;" v-for="(attrItem,attrIndex) in item.attributes">
												<div
													style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
													<div :style="{
														 	color:layoutConfig.right.tabColor.titColor
														 }" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
														{{attrItem.attribute}}
													</div>
													<div :style="{
														 	color:layoutConfig.right.tabColor.titColor
														 }" style="padding-left: 20px;padding: 6px;">
														{{attrItem.attribute_value}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</el-collapse-item>


								<el-collapse-item style="border-bottom: solid 1px #cccccc;"
									v-show="layoutConfig.right.showComment && sortItem.value == 'coment'"
									:title="$t('h.commentTit')" name="comment">
									<div v-loading="commentCommentsLoad" style="width: 100%;min-height: 60px;">

										<div style="margin: 0px 20px;" v-if="goodsData.lcomment == 1"
											v-loading="loadingComment">
											<div v-for="(item,index) in evaluationForm" :key="index">
												<el-form :style="{
													 	'--formLabelColor':layoutConfig.right.tabColor.titColor
													 }" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
													class="demo-ruleForm">
													<el-form-item :label="$t('h.author')" prop="comment_user_name">
														<el-input show-word-limit :maxlength="50"
															:placeholder="$t('h.peleaseIpt')" :rows="1"
															v-model="item.comment_user_name"></el-input>
													</el-form-item>

													<el-form-item :label="$t('h.comment')" prop="content_text">
														<el-input show-word-limit :maxlength="350"
															:placeholder="$t('h.peleaseIpt')" :rows="3" type="textarea"
															v-model="item.content_text"></el-input>
													</el-form-item>
													<el-form-item v-if="goodsData.content_type == 2" style="width: 42%;"
														:label="$t('h.img')">
														<van-uploader max-count="5" :preview-full-image="false" @delete="
																(file,fileIndex)=>{
																	deleteImgEvaluation(file,fileIndex,item)
																}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
																	afterReadEvaluation(file, fileItem,item)
																}" />
													</el-form-item>
													<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
														<van-rate color="#ffaa00" touchable v-model="item.score" />
													</el-form-item>
												</el-form>
											</div>

											<div style="display: flex;align-items: center;">
												<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
														size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
												<el-button class="btn"
													style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
													size="mini" @click="upComments()">{{$t('h.confirm')}}</el-button>
											</div>
										</div>

										<el-empty v-if="commentdata && commentdata.length == 0"
											:description="$t('h.noContent')"></el-empty>
										<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
												style="width: 100%;display: flex;align-items: center;justify-content: center;">
												<el-button
													style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
													size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
											</div> -->
										<div v-if="commentdata " style="width: 100%;">
											<div v-for="(item,index) in commentdata" :key="index" style="width: 100%;">

												<div style="display: flex;width: 100%;align-items: center;">
													<div
														style="display: flex;flex-direction: column;align-items: center;width: 120px;margin-left: 20px;">
														<div style="width: 40px;height: 40px;border-radius: 100%;">
															<img v-if="item.avatar" :src="item.avatar"
																style="width: 40px;height: 40px;border-radius: 100%;" />
														</div>
														<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}" style="font-size: 14px;color: #9fa19f;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
															{{item.user_name}}
														</div>
													</div>
													<div style="margin-left: 20px;width: calc(100% - 120px);">
														<div
															style="margin-top: 10px;font-size: 14px;color: #9fa19f;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
															<div :style="{
																	color:layoutConfig.right.tabColor.titColor
																}">{{item.content}}</div>
														</div>
														<div style="margin-top: 10px;">
															<el-image v-for="(imgItem,imgIndex) in item.imgs"
																:key="imgIndex" style="width: 100px; height: 100px"
																:src="imgItem" :preview-src-list="item.imgs">
															</el-image>
														</div>
														<div style="margin-top: 10px
															;"><van-rate color="#ffaa00" touchable v-model="item.score" /></div>
														<div style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
															<div :style="{
																	color:layoutConfig.right.tabColor.titColor
																}">{{item.created_at}}</div>
														</div>
													</div>
												</div>
												<div
													style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
												</div>
											</div>

											<div v-if="commentdata && commentdata.length > 0"
												style="width: 100%;display: flex;justify-content: center;">
												<div style="display: flex;align-items: center;">
													<el-pagination :style="{
															'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
															'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
														}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}" style="margin: 10px;"
														layout="prev, pager, next" :total="contentTotal">
													</el-pagination>
													<div :style="{
															color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
														}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
												</div>
											</div>
										</div>
									</div>
								</el-collapse-item>
							</div>




						</el-collapse>
					</div>

					<div v-if="layoutConfig.right.detailModel == 'block' && layoutConfig.right.titSet.position == '3'"
						style="margin-top: 20px;">
						<div v-if="layoutConfig.right.detailModel == 'block'" :style="{...getDetailBorder()}">
							<div v-if="layoutConfig.right.detailModel == 'block'" style="margin-top: 20px;margin: auto;"
								:style="{width:layoutConfig.bto.widthType == 'px'?layoutConfig.bto.width + 'px':'100%'}">
								<div style="width: 100%;" :style="getBgStyle(layoutConfig.bto)">
									<div style="display: flex;justify-content: center;flex-direction: column;">
										<div v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort"
											:key="sortIndex">
											<div style="margin-left: 10px;margin-top: 10px;"
												v-if="layoutConfig.right.showDetail && sortItem.value == 'detail'"
												:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}">
												{{$t('h.productDetail')}}
											</div>
											<div v-if="goodsData.product.description && layoutConfig.right.showDetail && sortItem.value == 'detail'"
												class="ql-container ql-snow" style="border:none;">
												<div class="ql-editor" style="width: fit-content;border:none; ">
													<div :style="{
													 	color:layoutConfig.right.tabColor.titColor
													 }" v-html="goodsData.product.description">{{goodsData.product.description}}}
													</div>
												</div>
											</div>
											<div v-if="layoutConfig.right.showAttr && sortItem.value == 'attr'"
												:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
												style="margin-left: 10px;cursor: pointer;margin-top: 10px;">
												{{$t('h.attribute')}}
											</div>
											<div v-if="layoutConfig.right.showAttr  && sortItem.value == 'attr'"
												style="width: 100%;font-size: 14px;margin-top: 20px;">
												<div style="width: 100%"
													v-for="(item,index) in goodsData.product.attributes" :key="index">
													<div style="border: solid 1px #c6c7c8;">
														<div :style="{
														 	color:layoutConfig.right.tabColor.titColor
														 }" style="padding: 6px;">
															{{item.attribute_group_name}}
														</div>
													</div>
													<div style="width: 100%;"
														v-for="(attrItem,attrIndex) in item.attributes">
														<div
															style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
															<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
																<!-- <img style="position: absolute;top: 0;left: 0;width: 100%;"
																	class="child" @mouseenter.stop.prevent="handleMouseEnter"
																	@mouseleave.stop.prevent="handleMouseLeave" :src="selectImg"
																	:style="{maxHeight:getObjectFit() == 'cover'?getMaxHeight():getMaxHeight(), objectFit:getObjectFit(),maxWidth: getMainImgMaxWidth(),width:layoutConfig.left.percentWidthSwitch?getMainImgWidth('fill'):getMainImgWidth('noFill'),height:layoutConfig.left.preViewImgHeight + 'px',...imageStyle,...getBorder(),...getBoderRadius()}" /> -->
																{{attrItem.attribute}}
															</div>
															<div :style="{
															 	color:layoutConfig.right.tabColor.titColor
															 }" style="padding-left: 20px;padding: 6px;">
																{{attrItem.attribute_value}}
															</div>
														</div>
													</div>
												</div>
											</div>
											<div v-if="layoutConfig.right.showComment  && sortItem.value == 'coment'"
												:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
												style="margin-left: 10px;cursor: pointer;margin-top: 10px;">
												{{$t('h.commentTit')}}
											</div>
											<div v-loading="commentCommentsLoad"
												style="width: 100%;min-height: 60px;margin-top: 20px;"
												v-if="layoutConfig.right.showComment && sortItem.value == 'coment'">
												<div style="margin: 20px;" v-if="goodsData.lcomment == 1"
													v-loading="loadingComment">
													<div v-for="(item,index) in evaluationForm" :key="index">
														<el-form :style="{
														 	'--formLabelColor':layoutConfig.right.tabColor.titColor
														 }" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
															class="demo-ruleForm">
															<el-form-item :label="$t('h.author')"
																prop="comment_user_name">
																<el-input show-word-limit :maxlength="50"
																	:placeholder="$t('h.peleaseIpt')" :rows="1"
																	v-model="item.comment_user_name"></el-input>
															</el-form-item>

															<el-form-item :label="$t('h.comment')" prop="content_text">
																<el-input show-word-limit :maxlength="350"
																	:placeholder="$t('h.peleaseIpt')" :rows="3"
																	type="textarea"
																	v-model="item.content_text"></el-input>
															</el-form-item>
															<el-form-item v-if="goodsData.content_type == 2"
																style="width: 42%;" :label="$t('h.img')">
																<van-uploader max-count="5" :preview-full-image="false"
																	@delete="
																	(file,fileIndex)=>{
																		deleteImgEvaluation(file,fileIndex,item)
																	}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
																		afterReadEvaluation(file, fileItem,item)
																	}" />
															</el-form-item>
															<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
																<van-rate color="#ffaa00" touchable
																	v-model="item.score" />
															</el-form-item>
														</el-form>
													</div>

													<div style="display: flex;align-items: center;">
														<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
															size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
														<el-button class="btn"
															style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
															size="mini"
															@click="upComments()">{{$t('h.confirm')}}</el-button>
													</div>
												</div>



												<el-empty v-if="commentdata && commentdata.length == 0"
													:description="$t('h.noContent')"></el-empty>
												<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
													style="width: 100%;display: flex;align-items: center;justify-content: center;">
													<el-button
														style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
														size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
												</div> -->
												<div v-if="commentdata " style="width: 100%;">
													<div v-for="(item,index) in commentdata" :key="index"
														style="width: 100%;">
														<div style="display: flex;width: 100%;align-items: center;">
															<div
																style="display: flex;flex-direction: column;align-items: center;width: 120px;margin-left: 20px;">
																<div v-if="item.avatar"
																	style="width: 40px;height: 40px;border-radius: 100%;">
																	<img v-if="item.avatar" :src="item.avatar"
																		style="width: 40px;height: 40px;border-radius: 100%;" />
																</div>
																<div :style="{
																	color:layoutConfig.right.tabColor.titColor
																}" style="font-size: 14px;color: #9fa19f;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
																	{{item.user_name}}
																</div>
															</div>
															<div
																style="margin-left: 20px;max-width: calc(100% - 120px);">
																<div
																	style="margin-top: 10px;font-size: 14px;color: #9fa19f;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
																	<div :style="{
																		color:layoutConfig.right.tabColor.titColor
																	}">{{item.content}}</div>
																</div>
																<div style="margin-top: 10px;">
																	<el-image v-for="(imgItem,imgIndex) in item.imgs"
																		:key="imgIndex"
																		style="width: 100px; height: 100px"
																		:src="imgItem" :preview-src-list="item.imgs">
																	</el-image>
																</div>
																<div style="margin-top: 10px;"><van-rate color="#ffaa00"
																		touchable v-model="item.score" /></div>
																<div
																	style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
																	<div :style="{
																		color:layoutConfig.right.tabColor.titColor
																	}">{{item.created_at}}</div>
																</div>
															</div>
														</div>
														<div
															style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
														</div>
													</div>
													<div v-if="commentdata && commentdata.length > 0"
														style="width: 100%;display: flex;justify-content: center;">
														<div style="display: flex;align-items: center;">
															<el-pagination :style="{
																'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
																'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
															}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}"
																style="margin: 10px;" layout="prev, pager, next"
																:total="contentTotal">
															</el-pagination>
															<div :style="{
																color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
															}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
														</div>
													</div>
												</div>
											</div>

										</div>

									</div>
								</div>
							</div>
						</div>
					</div>





					<iframe v-if="layoutConfig.right.htmlCode != ''" style="border: solid 0px #fff;" width="100%"
						@load="onIframeLoad" scrolling="no" seamless allowfullscreen class="preview-frame"
						:srcdoc="layoutConfig.right.htmlCode" ref="iframe"></iframe>
				</div>
			</div>
			<div v-if="layoutConfig.right.detailModel == 'block' && layoutConfig.right.titSet.position == '1'"
				style="margin-top: 20px;">
				<div v-if="layoutConfig.right.detailModel == 'block'" :style="{...getDetailBorder()}">
					<div v-if="layoutConfig.right.detailModel == 'block'" style="margin-top: 20px;margin: auto;"
						:style="{width:layoutConfig.bto.widthType == 'px'?layoutConfig.bto.width + 'px':'100%'}">
						<div style="width: 100%;" :style="getBgStyle(layoutConfig.bto)">
							<div style="display: flex;justify-content: center;flex-direction: column;">
								<div v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort" :key="sortIndex">
									<div style="margin-left: 10px;margin-top: 10px;"
										v-if="layoutConfig.right.showDetail && sortItem.value == 'detail'"
										:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}">
										{{$t('h.productDetail')}}
									</div>
									<div v-if="goodsData.product.description && layoutConfig.right.showDetail && sortItem.value == 'detail'"
										class="ql-container ql-snow" style="border:none;">
										<div class="ql-editor" style="width: fit-content;border:none; ">
											<div :style="{
											 	color:layoutConfig.right.tabColor.titColor
											 }" v-html="goodsData.product.description">{{goodsData.product.description}}}
											</div>
										</div>
									</div>
									<div v-if="layoutConfig.right.showAttr && sortItem.value == 'attr'"
										:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
										style="margin-left: 10px;cursor: pointer;margin-top: 10px;">
										{{$t('h.attribute')}}
									</div>
									<div v-if="layoutConfig.right.showAttr  && sortItem.value == 'attr'"
										style="width: 100%;font-size: 14px;margin-top: 20px;">
										<div style="width: 100%" v-for="(item,index) in goodsData.product.attributes"
											:key="index">
											<div style="border: solid 1px #c6c7c8;">
												<div :style="{
												 	color:layoutConfig.right.tabColor.titColor
												 }" style="padding: 6px;">
													{{item.attribute_group_name}}
												</div>
											</div>
											<div style="width: 100%;" v-for="(attrItem,attrIndex) in item.attributes">
												<div
													style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
													<div :style="{
														color:layoutConfig.right.tabColor.titColor
													}" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
														<!-- <img style="position: absolute;top: 0;left: 0;width: 100%;"
															class="child" @mouseenter.stop.prevent="handleMouseEnter"
															@mouseleave.stop.prevent="handleMouseLeave" :src="selectImg"
															:style="{maxHeight:getObjectFit() == 'cover'?getMaxHeight():getMaxHeight(), objectFit:getObjectFit(),maxWidth: getMainImgMaxWidth(),width:layoutConfig.left.percentWidthSwitch?getMainImgWidth('fill'):getMainImgWidth('noFill'),height:layoutConfig.left.preViewImgHeight + 'px',...imageStyle,...getBorder(),...getBoderRadius()}" /> -->
														{{attrItem.attribute}}
													</div>
													<div :style="{
													 	color:layoutConfig.right.tabColor.titColor
													 }" style="padding-left: 20px;padding: 6px;">
														{{attrItem.attribute_value}}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div v-if="layoutConfig.right.showComment  && sortItem.value == 'coment'"
										:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
										style="margin-left: 10px;cursor: pointer;margin-top: 10px;">
										{{$t('h.commentTit')}}
									</div>
									<div v-loading="commentCommentsLoad"
										style="width: 100%;min-height: 60px;margin-top: 20px;"
										v-if="layoutConfig.right.showComment && sortItem.value == 'coment'">
										<div style="margin: 20px;" v-if="goodsData.lcomment == 1"
											v-loading="loadingComment">
											<div v-for="(item,index) in evaluationForm" :key="index">
												<el-form :style="{
												 	'--formLabelColor':layoutConfig.right.tabColor.titColor
												 }" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
													class="demo-ruleForm">
													<el-form-item :label="$t('h.author')" prop="comment_user_name">
														<el-input show-word-limit :maxlength="50"
															:placeholder="$t('h.peleaseIpt')" :rows="1"
															v-model="item.comment_user_name"></el-input>
													</el-form-item>

													<el-form-item :label="$t('h.comment')" prop="content_text">
														<el-input show-word-limit :maxlength="350"
															:placeholder="$t('h.peleaseIpt')" :rows="3" type="textarea"
															v-model="item.content_text"></el-input>
													</el-form-item>
													<el-form-item v-if="goodsData.content_type == 2" style="width: 42%;"
														:label="$t('h.img')">
														<van-uploader max-count="5" :preview-full-image="false" @delete="
															(file,fileIndex)=>{
																deleteImgEvaluation(file,fileIndex,item)
															}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
																afterReadEvaluation(file, fileItem,item)
															}" />
													</el-form-item>
													<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
														<van-rate color="#ffaa00" touchable v-model="item.score" />
													</el-form-item>
												</el-form>
											</div>

											<div style="display: flex;align-items: center;">
												<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
													size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
												<el-button class="btn"
													style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
													size="mini" @click="upComments()">{{$t('h.confirm')}}</el-button>
											</div>
										</div>



										<el-empty v-if="commentdata && commentdata.length == 0"
											:description="$t('h.noContent')"></el-empty>
										<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
											style="width: 100%;display: flex;align-items: center;justify-content: center;">
											<el-button
												style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
												size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
										</div> -->
										<div v-if="commentdata " style="width: 100%;">
											<div v-for="(item,index) in commentdata" :key="index" style="width: 100%;">
												<div style="display: flex;width: 100%;align-items: center;">
													<div
														style="display: flex;flex-direction: column;align-items: center;width: 120px;margin-left: 20px;">
														<div v-if="item.avatar"
															style="width: 40px;height: 40px;border-radius: 100%;">
															<img v-if="item.avatar" :src="item.avatar"
																style="width: 40px;height: 40px;border-radius: 100%;" />
														</div>
														<div :style="{
															color:layoutConfig.right.tabColor.titColor
														}" style="font-size: 14px;color: #9fa19f;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
															{{item.user_name}}
														</div>
													</div>
													<div style="margin-left: 20px;max-width: calc(100% - 120px);">
														<div
															style="margin-top: 10px;font-size: 14px;color: #9fa19f;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
															<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}">{{item.content}}</div>
														</div>
														<div style="margin-top: 10px;">
															<el-image v-for="(imgItem,imgIndex) in item.imgs"
																:key="imgIndex" style="width: 100px; height: 100px"
																:src="imgItem" :preview-src-list="item.imgs">
															</el-image>
														</div>
														<div style="margin-top: 10px;"><van-rate color="#ffaa00"
																touchable v-model="item.score" /></div>
														<div style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
															<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}">{{item.created_at}}</div>
														</div>
													</div>
												</div>
												<div
													style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
												</div>
											</div>
											<div v-if="commentdata && commentdata.length > 0"
												style="width: 100%;display: flex;justify-content: center;">
												<div style="display: flex;align-items: center;">
													<el-pagination :style="{
														'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
														'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
													}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}" style="margin: 10px;"
														layout="prev, pager, next" :total="contentTotal">
													</el-pagination>
													<div :style="{
														color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
													}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
												</div>
											</div>
										</div>
									</div>

								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
			<div style="margin-top: 15px;padding-bottom: 1px;"
				v-if="layoutConfig.right.detailModel == 'accordion'  && layoutConfig.right.titSet.position == '1'"
				:style="{...getDetailBorder(),...getBgStyle(layoutConfig.bto)}">
				<el-collapse :style="{
					'--bgColor':layoutConfig.bto.singleBgColor?layoutConfig.bto.singleBgColor :'#fff',
					'--fontColor':layoutConfig.right.tabColor.titColor?layoutConfig.right.tabColor.titColor:'#000',
					'--collapseFontSize':layoutConfig.right.tabFontSize + 'px'
				}" v-model="tabShow" accordion>
					<div style="width:100%" v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort"
						:key="sortIndex">
						<el-collapse-item v-show="layoutConfig.right.showDetail && sortItem.value == 'detail'"
							:title="$t('h.productDetail')" name="detail">
							<div class="ql-container ql-snow" style="border:none;">
								<div class="ql-editor" style="width: fit-content;border:none; ">
									<div v-html="goodsData.product.description">{{goodsData.product.description}}}</div>
								</div>
							</div>
						</el-collapse-item>
						<el-collapse-item v-show="layoutConfig.right.showAttr && sortItem.value == 'attr'"
							:title="$t('h.attribute')" name="size">
							<div style="width: 100%;font-size: 14px;">
								<div style="width: 100%" v-for="(item,index) in goodsData.product.attributes"
									:key="index">
									<div style="border: solid 1px #c6c7c8;">
										<div :style="{
											 	color:layoutConfig.right.tabColor.titColor
											 }" style="padding: 6px;">
											{{item.attribute_group_name}}
										</div>
									</div>
									<div style="width: 100%;" v-for="(attrItem,attrIndex) in item.attributes">
										<div style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
											<div :style="{
												 	color:layoutConfig.right.tabColor.titColor
												 }" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
												{{attrItem.attribute}}
											</div>
											<div :style="{
												 	color:layoutConfig.right.tabColor.titColor
												 }" style="padding-left: 20px;padding: 6px;">
												{{attrItem.attribute_value}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</el-collapse-item>


						<el-collapse-item style="border-bottom: solid 1px #cccccc;"
							v-show="layoutConfig.right.showComment && sortItem.value == 'coment'"
							:title="$t('h.commentTit')" name="comment">
							<div v-loading="commentCommentsLoad" style="width: 100%;min-height: 60px;">

								<div style="margin: 0px 20px;" v-if="goodsData.lcomment == 1"
									v-loading="loadingComment">
									<div v-for="(item,index) in evaluationForm" :key="index">
										<el-form :style="{
											 	'--formLabelColor':layoutConfig.right.tabColor.titColor
											 }" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
											class="demo-ruleForm">
											<el-form-item :label="$t('h.author')" prop="comment_user_name">
												<el-input show-word-limit :maxlength="50"
													:placeholder="$t('h.peleaseIpt')" :rows="1"
													v-model="item.comment_user_name"></el-input>
											</el-form-item>

											<el-form-item :label="$t('h.comment')" prop="content_text">
												<el-input show-word-limit :maxlength="350"
													:placeholder="$t('h.peleaseIpt')" :rows="3" type="textarea"
													v-model="item.content_text"></el-input>
											</el-form-item>
											<el-form-item v-if="goodsData.content_type == 2" style="width: 42%;"
												:label="$t('h.img')">
												<van-uploader max-count="5" :preview-full-image="false" @delete="
														(file,fileIndex)=>{
															deleteImgEvaluation(file,fileIndex,item)
														}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
															afterReadEvaluation(file, fileItem,item)
														}" />
											</el-form-item>
											<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
												<van-rate color="#ffaa00" touchable v-model="item.score" />
											</el-form-item>
										</el-form>
									</div>

									<div style="display: flex;align-items: center;">
										<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
												size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
										<el-button class="btn"
											style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
											size="mini" @click="upComments()">{{$t('h.confirm')}}</el-button>
									</div>
								</div>

								<el-empty v-if="commentdata && commentdata.length == 0"
									:description="$t('h.noContent')"></el-empty>
								<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
										style="width: 100%;display: flex;align-items: center;justify-content: center;">
										<el-button
											style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
											size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
									</div> -->
								<div v-if="commentdata " style="width: 100%;">
									<div v-for="(item,index) in commentdata" :key="index" style="width: 100%;">

										<div style="display: flex;width: 100%;align-items: center;">
											<div
												style="display: flex;flex-direction: column;align-items: center;width: 120px;margin-left: 20px;">
												<div style="width: 40px;height: 40px;border-radius: 100%;">
													<img v-if="item.avatar" :src="item.avatar"
														style="width: 40px;height: 40px;border-radius: 100%;" />
												</div>
												<div :style="{
														color:layoutConfig.right.tabColor.titColor
													}" style="font-size: 14px;color: #9fa19f;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
													{{item.user_name}}
												</div>
											</div>
											<div style="margin-left: 20px;width: calc(100% - 120px);">
												<div
													style="margin-top: 10px;font-size: 14px;color: #9fa19f;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
													<div :style="{
															color:layoutConfig.right.tabColor.titColor
														}">{{item.content}}</div>
												</div>
												<div style="margin-top: 10px;">
													<el-image v-for="(imgItem,imgIndex) in item.imgs" :key="imgIndex"
														style="width: 100px; height: 100px" :src="imgItem"
														:preview-src-list="item.imgs">
													</el-image>
												</div>
												<div style="margin-top: 10px
													;"><van-rate color="#ffaa00" touchable v-model="item.score" /></div>
												<div style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
													<div :style="{
															color:layoutConfig.right.tabColor.titColor
														}">{{item.created_at}}</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
										</div>
									</div>

									<div v-if="commentdata && commentdata.length > 0"
										style="width: 100%;display: flex;justify-content: center;">
										<div style="display: flex;align-items: center;">
											<el-pagination :style="{
													'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
													'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
												}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}" style="margin: 10px;"
												layout="prev, pager, next" :total="contentTotal">
											</el-pagination>
											<div :style="{
													color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
												}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
										</div>
									</div>
								</div>
							</div>
						</el-collapse-item>
					</div>




				</el-collapse>
			</div>

			<div style="width: 100%;margin-top: 20px;">
				<div v-if="layoutConfig.right.detailModel == 'label'  && layoutConfig.right.titSet.position == '1'"
					:style="{}">

					<div :style="{
							...getBgBtoTit(layoutConfig.right.titSet)
						}" style="display: flex;justify-content: center;cursor: pointer;margin-top: 10px;font-size: 16px;padding: 5px 0px;">
						<div style="" v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort" :key="sortIndex">
							<div v-if="layoutConfig.right.showDetail && sortItem.value == 'detail'"
								@click="tab = 'detail'" style="margin-right: 5px;margin-left: 5px;"
								:style="{
									marginLeft:layoutConfig.right.detailMl + 'px',
									marginRight:layoutConfig.right.detailMl + 'px',
									color:tab == 'detail'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}">
								{{$t('h.productDetail')}}
							</div>
							<div v-if="layoutConfig.right.showAttr && sortItem.value == 'attr'" @click="tab = 'size'"
								:style="{
									marginLeft:layoutConfig.right.detailMl + 'px',
									marginRight:layoutConfig.right.detailMl + 'px',
									color:tab == 'size'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
								style="margin-left: 5px;cursor: pointer;">
								{{$t('h.attribute')}}
							</div>
							<div v-if="layoutConfig.right.showComment && sortItem.value == 'coment'"
								@click="tab = 'comment';"
								:style="{
									marginLeft:layoutConfig.right.detailMl + 'px',
									marginRight:layoutConfig.right.detailMl + 'px',
									color:tab == 'comment'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
								style="margin-left: 5px;cursor: pointer;margin-right: 5px;">
								{{$t('h.commentTit')}}
							</div>
						</div>

					</div>


					<div style="margin-top: 10px;" :style="{...getDetailBorder()}">
						<div v-if="layoutConfig.right.detailModel == 'label'"
							style="margin-top: 20px;margin: auto;overflow: hidden;"
							:style="{width:layoutConfig.bto.widthType == 'px'?layoutConfig.bto.width + 'px':'100%'}">
							<div style="width: 100%;" :style="getBgStyle(layoutConfig.bto)">
								<div style="display: flex;justify-content: center;">
									<div v-if="tab == 'detail' && goodsData.product.description"
										class="ql-container ql-snow" style="border:none;">
										<div class="ql-editor" style="width: fit-content;border:none; ">
											<div :style="{
												color:layoutConfig.right.tabColor.titColor
											}" v-html="goodsData.product.description">
												{{goodsData.product.description}}}
											</div>
										</div>
									</div>
									<div v-if="tab == 'size'" style="width: 100%;font-size: 14px;">
										<div style="width: 100%" v-for="(item,index) in goodsData.product.attributes"
											:key="index">
											<div style="border: solid 1px #c6c7c8;">
												<div :style="{
													 color:layoutConfig.right.tabColor.titColor
												 }" style="padding: 6px;">
													{{item.attribute_group_name}}
												</div>
											</div>
											<div style="width: 100%;" v-for="(attrItem,attrIndex) in item.attributes">
												<div
													style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
													<div :style="{
														color:layoutConfig.right.tabColor.titColor
													}" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
														{{attrItem.attribute}}
													</div>
													<div :style="{
													 	color:layoutConfig.right.tabColor.titColor
													 }" style="padding-left: 20px;padding: 6px;">
														{{attrItem.attribute_value}}
													</div>
												</div>
											</div>
										</div>
									</div>

									<div v-loading="commentCommentsLoad" style="width: 100%;min-height: 60px;"
										v-if="tab == 'comment'">

										<div :style="{
										 	color:layoutConfig.right.tabColor.titColor
											
										 }" style="margin: 20px;" v-if="goodsData.lcomment == 1" v-loading="loadingComment">
											<div v-for="(item,index) in evaluationForm" :key="index">
												<el-form :style="{
													'--formLabelColor':layoutConfig.right.tabColor.titColor
												}" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
													class="demo-ruleForm">
													<el-form-item :label="$t('h.author')" prop="comment_user_name">
														<el-input show-word-limit :maxlength="50"
															:placeholder="$t('h.peleaseIpt')" :rows="1"
															v-model="item.comment_user_name"></el-input>
													</el-form-item>

													<el-form-item :label="$t('h.comment')" prop="content_text">
														<el-input show-word-limit :maxlength="350"
															:placeholder="$t('h.peleaseIpt')" :rows="3" type="textarea"
															v-model="item.content_text"></el-input>
													</el-form-item>
													<el-form-item v-if="goodsData.content_type == 2" style="width: 42%;"
														:label="$t('h.img')">
														<van-uploader max-count="5" :preview-full-image="false" @delete="
															(file,fileIndex)=>{
																deleteImgEvaluation(file,fileIndex,item)
															}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
																afterReadEvaluation(file, fileItem,item)
															}" />
													</el-form-item>
													<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
														<van-rate color="#ffaa00" touchable v-model="item.score" />
													</el-form-item>
												</el-form>
											</div>

											<div v-if="goodsData.lcomment == 1"
												style="display: flex;align-items: center;">
												<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
													size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
												<el-button class="btn"
													style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
													size="mini" @click="upComments()">{{$t('h.confirm')}}</el-button>
											</div>
										</div>


										<el-empty v-if="commentdata && commentdata.length == 0"
											:description="$t('h.noContent')"></el-empty>
										<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
											style="width: 100%;display: flex;align-items: center;justify-content: center;">
											<el-button
												style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
												size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
										</div> -->
										<div v-if="commentdata " style="width: 100%;">
											<div v-for="(item,index) in commentdata" :key="index" style="width: 100%;">

												<div style="display: flex;width: 100%;align-items: center;">
													<div
														style="display: flex;flex-direction: column;align-items: center;margin-left: 20px;justify-content: center;width: 120px;">
														<div v-if="item.avatar"
															style="width: 40px;height: 40px;border-radius: 100%;">
															<img v-if="item.avatar" :src="item.avatar"
																style="width: 40px;height: 40px;border-radius: 100%;" />
														</div>
														<div :style="{
															color:layoutConfig.right.tabColor.titColor
														}" style="font-size: 14px;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
															{{item.user_name}}
														</div>
													</div>
													<div style="margin-left: 20px;max-width: calc(100% - 120px);">
														<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}" style="margin-top: 10px;font-size: 14px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
															<div>{{item.content}}</div>
														</div>
														<div style="margin-top: 10px;">
															<el-image v-for="(imgItem,imgIndex) in item.imgs"
																:key="imgIndex" style="width: 100px; height: 100px"
																:src="imgItem" :preview-src-list="item.imgs">
															</el-image>
														</div>
														<div style="margin-top: 10px
														;"><van-rate color="#ffaa00" touchable v-model="item.score" /></div>
														<div :style="{
														 	color:layoutConfig.right.tabColor.titColor
														 }" style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
															<div>{{item.created_at}}</div>
														</div>
													</div>
												</div>
												<div
													style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
												</div>
											</div>

											<div v-if="commentdata && commentdata.length > 0"
												style="width: 100%;display: flex;justify-content: center;">
												<div style="display: flex;align-items: center;">
													<el-pagination :style="{
														'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
														'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
													}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}" style="margin: 10px;"
														layout="prev, pager, next" :total="contentTotal">
													</el-pagination>
													<div :style="{
														color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
													}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="height: 100%;width: 100%;overflow-y: scroll;" v-if="equipment == 'phone' && goodsData">
			<el-carousel v-if="!videoPlay" id="carousel" @change="changeCarousel" ref="carousel"
				:initial-index="initialIndex"
				:height="layoutConfig.left.preViewImgPhoneWidth == layoutConfig.left.preViewImgPhoneHeight?layoutConfig.left.preViewImgPhoneWidth > cWidth?(cWidth +'px') :(layoutConfig.left.preViewImgPhoneWidth + 'px'): layoutConfig.left.preViewImgPhoneHeight + 'px'">
				<el-carousel-item :style="{
					aspectRatio:getAspectRatioPhone(layoutConfig.left),
				}" style="display: flex;justify-content: center;display: flex;align-items: center;justify-content: center;background-color: #fff;"
					v-for="(item,index) in goodsData.product.images" :key="index">
					<img style="max-width: 100%;" :style="{
								height:layoutConfig.left.preViewImgPhoneHeight + 'px',
								width:layoutConfig.left.preViewImgPhoneWidth + 'px',objectFit:getObjectFit()}" :src="item.preview" />
					<div @click="playVideo" v-if="goodsData.product.video != '' && isMp4(goodsData.product.video)"
						style="position: absolute;width: 42px;height: 42px;z-index: 1000;border-radius: 100%;border: solid 6px #fff;display: flex;align-items: center;justify-content: center;">
						<i style="font-size: 28px;color: #ffffff;cursor: pointer;" class="el-icon-caret-right"></i>
					</div>
				</el-carousel-item>

			</el-carousel>

			<el-carousel v-if="videoPlay" id="carousel" @change="changeCarousel" ref="carousel"
				:initial-index="initialIndex"
				:height="layoutConfig.left.preViewImgPhoneWidth == layoutConfig.left.preViewImgPhoneHeight?layoutConfig.left.preViewImgPhoneWidth > cWidth?(cWidth +'px') :(layoutConfig.left.preViewImgPhoneWidth + 'px'): layoutConfig.left.preViewImgPhoneHeight + 'px'">
				<el-carousel-item :style="{
					aspectRatio:getAspectRatioPhone(layoutConfig.left),
				}" style="display: flex;justify-content: center;display: flex;align-items: center;justify-content: center;background-color: #fff;">
					<div v-if="goodsData.product.video != '' && videoPlay"
						style="width: 100%;position: relative;display: flex;align-items: center;justify-content: center;background-color: #cfd1cf;height: 100%;"
						:style="{
						aspectRatio:getAspectRatioPhone(layoutConfig.left)}">
						<video id="myVideo" style="height: 100%;width: 100%;" muted :playsinline="true"
							:webkit-playsinline="true" controls>
							<source :src="goodsData.product.video" type="video/mp4">
						</video>
						<div @click="videoPlay = false" style="position: absolute;z-index: 100;right: 10px;top: 10px;">
							<i style="font-size: 28px;color: #ffffff;cursor: pointer;" class="el-icon-circle-close"></i>
						</div>
					</div>
				</el-carousel-item>




			</el-carousel>




			<PreciseDragScroll style="margin-top: 10px;">
				<div @click="selectGoodsImg(imgItem,imgIndex)" v-for="(imgItem,imgIndex) in goodsData.product.images"
					:key="imgIndex"
					:style="{height:layoutConfig.left.preViewListImgPhoneWidth + 'px',width:layoutConfig.left.preViewListImgPhoneWidth + 'px'}">
					<img :src="imgItem.preview"
						:style="{
							...getAffiliatedBorder(imgItem,imgIndex),...getAffiliatedBoderRadius(),
							width:(layoutConfig.left.preViewListImgPhoneWidth - 3) + 'px',height:(layoutConfig.left.preViewListImgPhoneHeight - 3) + 'px'}"
						style="object-fit: fill;" />

				</div>
			</PreciseDragScroll>
			<div style="width: calc(100% - 12px);word-wrap: break-word;overflow-wrap: break-word;white-space: normal;margin: auto;margin-top: 10px;"
				:style="{fontSize:(layoutConfig.right.titleSize - 3) + 'px',color:layoutConfig.right.titleColor,fontWeight:layoutConfig.right.titleBold}">
				{{goodsData.product.name}}
			</div>
			<div
				style="width: calc(100% - 12px);word-wrap: break-word;overflow-wrap: break-word;white-space: normal;margin: auto;display: flex;align-items: center;margin-top: 15px;">
				<div
					:style="{fontSize:(layoutConfig.right.priceSize - 3) + 'px',color:layoutConfig.right.priceColor,fontWeight:layoutConfig.right.priceBold}">
					{{sku.price_format}}
				</div>
				<div :style="{fontSize:(layoutConfig.right.discountSize - 3) + 'px',color:layoutConfig.right.discountColor,fontWeight:layoutConfig.right.discountBold}"
					style="margin-left: 20px; text-decoration: line-through;">
					{{sku.origin_price_format}}
				</div>
			</div>
			<div
				style="width: calc(100% - 12px);word-wrap: break-word;overflow-wrap: break-word;white-space: normal;margin: auto;display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;margin-top: 5px;">
				<div v-if="layoutConfig.right.showInventory"
					:style="{fontSize:(layoutConfig.right.InventorySize - 3) + 'px'}" class="title"
					style="display: flex;align-items: center;margin-top: 10px;">
					<div style="color: #9fa19f ;">
						{{$t('h.quantity')}}:
					</div>
					<div :style="{color:sku.quantity > 0 ?layoutConfig.right.InventoryColor:'#5a5a5a'}"
						style="margin-left: 4px;">
						{{sku.quantity > 0?$t('h.quantityExits'):$t('h.quantityNone')}}
					</div>
				</div>
				<div v-if="layoutConfig.right.showBrand" :style="{fontSize:(layoutConfig.right.brandSize - 3) + 'px'}"
					class="title" style="display: flex;align-items: center;margin-top: 10px;">
					<div style="color: #9fa19f ;">
						{{$t('h.brand')}}:
					</div>
					<div :style="{color:layoutConfig.right.brandColor}" style="margin-left: 4px;">
						{{goodsData.product.brand_name}}
					</div>
				</div>
				<div v-if="layoutConfig.right.showSKU" :style="{fontSize:(layoutConfig.right.skuSize - 3) + 'px'}"
					class="title" style="display: flex;align-items: center;margin-top: 10px;">
					<div style="color: #9fa19f ;">
						{{$t('h.sku')}}:
					</div>
					<div :style="{color:layoutConfig.right.skuColor}" style="margin-left: 4px;">
						{{sku.sku}}
					</div>
				</div>
				<div v-if="layoutConfig.right.showSize" :style="{fontSize:(layoutConfig.right.sSize - 3) + 'px'}"
					class="title" style="display: flex;align-items: center;margin-top: 10px;">
					<div style="color: #9fa19f ;">
						{{$t('h.model')}}:
					</div>
					<div :style="{color:layoutConfig.right.sColor}" style="margin-left: 4px;">
						{{sku.model}}
					</div>
				</div>
			</div>
			<div
				style="width: calc(100% - 12px);word-wrap: break-word;overflow-wrap: break-word;white-space: normal;margin: auto;display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;margin-top: 15px;">
				<div>
					<div :style="{fontSize:(layoutConfig.right.specSize - 3) + 'px'}"
						v-for="(item,index) in goodsData.product.variables" :key="index">
						<div style="margin-top: 4px;"
							:style="{color:layoutConfig.right.optionColor,fontSize:layoutConfig.right.optionSize}">
							{{item.name}}
						</div>
						<div style="width:fit-content;display: flex;align-items: center;flex-wrap: wrap;">
							<div @mouseenter.stop.prevent="enterSizeItem = value"
								@mouseleave.stop.prevent="enterSizeItem = null"
								@click.stop.prevent="selectValue(item,value,valueIndex,index)"
								:style="{
									padding:layoutConfig.right.showSelectImg?value.image?'0px':'4px':'4px',
									color:select['sku' + index +item.name].name == value.name ?layoutConfig.right.optionColor:getLightColor(layoutConfig.right.optionColor?layoutConfig.right.optionColor:'#000000'),...getBorderSize(item,value,index) ,fontSize:layoutConfig.right.optionSize + 'px',fontFamily:layoutConfig.right.optionFamily?layoutConfig.right.optionFamily:selectdItem.preStyle.font.fontFamily,...getBorderRadius(item,value)}"
								style="min-width: 40px;display: flex;align-items: center;justify-content: center;margin: 5px;border-radius: 4px;cursor: pointer;"
								v-for="(value,valueIndex) in item.values" :key="valueIndex">
								<div v-if="layoutConfig.right.showSelectImg?value.image?false:true:true">
									{{value.name}}
								</div>
								<div :style="{
									 height:equipment != 'phone'? layoutConfig.right.showSelectImgSet.height + 'px' : layoutConfig.right.showSelectImgSet.phoneHeight + 'px',
									 width:equipment != 'phone'? layoutConfig.right.showSelectImgSet.width + 'px' : layoutConfig.right.showSelectImgSet.phoneWidth + 'px'
								 }" v-if="layoutConfig.right.showSelectImg?value.image?true:false:false">
									<img :style="{
										...getBorderRadius(item,value),
										objectFit:layoutConfig.right.showSelectImgSet.mode,
									}" :src="value.image" style="width: 100%;height: 100%;">
								</div>
							</div>
						</div>
					</div>
					
					
					<div v-if="goodsData.product.options && goodsData.product.options.length > 0">
						<div  :style="{fontSize:layoutConfig.right.specSize + 'px',marginTop:index!=0?'2px':'0px',}"
							v-for="(item,index) in goodsData.product.options" :key="index">
							<div :style="{
								color:layoutConfig.right.optionColor,fontSize:layoutConfig.right.optionSize + 'px',fontFamily:layoutConfig.right.optionFamily?layoutConfig.right.optionFamily:selectdItem.preStyle.font.fontFamily
								}">
								{{item.option_name}} <span style="margin-left: 4px;" v-if="getAddOstionPrice(item) != '0.00'">( + {{getAddOstionPrice(item)}} )</span>
							</div>
							<div style="width:fit-content;display: flex;align-items: flex-start;flex-wrap: wrap;margin-top:2px">
								<div @mouseenter.stop.prevent="enterSizeItem = {item,index,value,valueIndex}"
									@mouseleave.stop.prevent="enterSizeItem = null"
									@click="changeOptionsSelect(item,index,value,valueIndex)"
									:style="{
										...!value.ciopimage?getSelectTabBgColorCustomize(select,item,index,value,valueIndex):{},
										...!value.ciopimage?getBorderSizeCustomize(item,index,value,valueIndex):{},
										fontSize:layoutConfig.right.optionSize + 'px',
										fontFamily:layoutConfig.right.optionFamily?layoutConfig.right.optionFamily:selectdItem.preStyle.font.fontFamily,
										...getBorderRadiusCustomize(item,index,value,valueIndex),
										color:getSelectTabColorCustomize(select,item,index,value,valueIndex),fontSize:layoutConfig.right.optionSize + 'px'}"
									style="min-width: 50px;display: flex;align-items: center;justify-content: center;margin: 5px;cursor: pointer;padding: 4px;flex-direction: column;"
									v-for="(value,valueIndex) in item.values" :key="valueIndex">
									
									<!-- ...getSelectTabBgColorCustomize(select,item,index,value,valueIndex), -->
									<div :style="{
										
										...value.ciopimage?getBorderSizeCustomize(item,index,value,valueIndex):{},
										 height:equipment != 'phone'? layoutConfig.right.showSelectImgSet.height + 'px' : layoutConfig.right.showSelectImgSet.phoneHeight + 'px',
										 width:equipment != 'phone'? layoutConfig.right.showSelectImgSet.width + 'px' : layoutConfig.right.showSelectImgSet.phoneWidth + 'px'
									 }" v-if="value.ciopimage">
										<img :style="{
											...getBorderRadiusCustomize(item,index,value,valueIndex),
											objectFit:layoutConfig.right.showSelectImgSet.mode,
										}" :src="value.ciopimage" style="width: 100%;height: 100%;">
									</div>
									
									<div :style="{
										 width:equipment != 'phone'? layoutConfig.right.showSelectImgSet.width + 'px' : layoutConfig.right.showSelectImgSet.phoneWidth + 'px'
									}" style="margin-top:2px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;text-align:center">
										{{value.value_name}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div v-if="goodsData.product.options && goodsData.product.options.length > 0" style="margin-top: 10px;font-weight: bold;margin-left: 6px;" :style="{fontSize:layoutConfig.right.priceSize + 'px',color:layoutConfig.right.priceColor,fontWeight:layoutConfig.right.priceBold,fontFamily:layoutConfig.right.priceFontFamily}">
				<div>{{$t('h.customizationFee')}} + {{ sku.price_format.substring(0, 1)}}{{getAddOstionPriceAll()}}</div>
				<div style="margin-top: 6px;">{{$t('h.priceTotal')}} {{ sku.price_format.substring(0, 1)}}{{sku.price + getAddOstionPriceAll()}} </div>
			</div>
			<div v-if="layoutConfig.right.phoneBtnP == 'top'" class="bto"
				style="display: flex;align-items: center;font-size: 16px;margin: 8px;flex-wrap: wrap;">
				<van-stepper v-if="layoutConfig.right.showAddNum" button-size="30px" input-width="40px" :style="{
						width:layoutConfig.right.rightBtn.phoneAddNumFull? '100%' : 'fit-content'
					}" style="margin-right: 10px;background-color: #fff;width: 100%;margin-top: 20px;" v-model="order.num" min="1"
					max="800000000000000000000000000000" />
				<div v-if="layoutConfig.right.rightBtn" :style="{
				 	minWidth:layoutConfig.right.rightBtn.phoneAddCartFull? '100%' : (this.cWidth  - 32)> layoutConfig.right.rightBtn.phoneAddCartWidth?layoutConfig.right.rightBtn.phoneAddCartWidth + 'px': '100%'
				 }" style="margin-top: 20px;margin-right: 10px;max-width:100%;">
					<div v-if="layoutConfig.right.showAddCart" @click="addCarts" class="add-cart" :style="{
							border:`solid 1px ${layoutConfig.right.rightBtnColor.addCart.border.color}`,
							...getBtnBgColor(layoutConfig.right.rightBtnColor.addCart),
								color:layoutConfig.right.rightBtnColor.addCart.color,
							width:(this.cWidth  - 32)> layoutConfig.right.rightBtn.phoneAddCartWidth?layoutConfig.right.rightBtn.phoneAddCartWidth + 'px': '100%'
							
							
							
						}" style="max-width:100%;height: 28px;padding: 4px 0px;border: solid 1px #000000;display: flex;align-items: center;justify-content: center;border-radius: 5px;font-weight: 400;background-color: #fff;font-size: 14px;
						;">
						<i class="el-icon-shopping-cart-2" style="margin-top: 2px;"></i>
						<span style="margin-left: 2px;cursor: pointer;">
							{{$t('h.addCart')}}
						</span>
					</div>
				</div>
				<div :style="{
				 	minWidth:layoutConfig.right.rightBtn.phoneBuyNowFull? '100%' : (this.cWidth  - 32)> layoutConfig.right.rightBtn.phoneAddCartWidth?layoutConfig.right.rightBtn.phoneAddCartWidth + 'px': '100%'
				 }" style="margin-top: 20px;margin-right: 10px;max-width:100%;">
					<div v-if="layoutConfig.right.showBuyNow" @click="buyNow" :style="{
							border:`solid 1px ${layoutConfig.right.rightBtnColor.buyNow.border.color}`,
							...getBtnBgColor(layoutConfig.right.rightBtnColor.buyNow),
							color:layoutConfig.right.rightBtnColor.buyNow.color,
							width:(this.cWidth  - 32)> layoutConfig.right.rightBtn.phoneAddCartWidth?layoutConfig.right.rightBtn.phoneAddCartWidth + 'px': '100%'
						}" style="max-width:100%;cursor: pointer;height: 28px;padding: 4px 0px;border: solid 1px #000000;display: flex;align-items: center;justify-content: center;border-radius: 5px;background-color: #000000;color: #fff;font-weight: 400;font-size: 14px;">
						<i class="el-icon-goods" style="margin-top: 2px;"></i>
						<span style="margin-left: 2px;">
							{{$t('h.buyNow')}}
						</span>
					</div>
				</div>
				<div :style="{
				 	minWidth:layoutConfig.right.rightBtn.phoneLoveFull? '100%' : 'fit-content'
				 }" style="margin-top: 20px;">
					<div v-if="layoutConfig.right.showLove" @click="collect"
						style="margin-left: 15px;font-size: 22px;cursor: pointer;">
						<i :style="{
							color:layoutConfig.right.rightBtnColor.love.bg.color
						}" v-if="!isCollct" class="el-icon-star-off"></i>
						<i :style="{
						 	color:layoutConfig.right.rightBtnColor.love.bg.color
						 }" v-if="isCollct" class="el-icon-star-on"></i>
					</div>
				</div>
			</div>

			<iframe v-if="layoutConfig.right.htmlCode != ''" style="border: solid 0px #fff;" width="100%"
				@load="onIframeLoad" scrolling="no" seamless allowfullscreen class="preview-frame"
				:srcdoc="layoutConfig.right.htmlCode" ref="iframe"></iframe>
			<!-- <div v-if="layoutConfig.right.phoneBtnP == 'top'" class="bto"
				style="margin-top: 15px;display: flex;align-items: center;font-size: 16px;margin-left: 20px;">
				<div v-if="layoutConfig.right.showAddCart" @click="addCarts" class="add-cart"
					style="width: fit-content;height: 34px;padding: 4px 12px;border: solid 1px #000000;display: flex;align-items: center;justify-content: center;border-radius: 5px;font-weight: 400;margin-right: 10px;background-color: #fff;">
					<i class="el-icon-shopping-cart-2" style="margin-top: 2px;"></i>
					<span style="margin-left: 2px;cursor: pointer;">
						{{$t('h.addCart')}}
					</span>
				</div>
				<div v-if="layoutConfig.right.showBuyNow" @click="buyNow"
					style="cursor: pointer;width: fit-content;height: 34px;padding: 4px 12px;border: solid 1px #000000;display: flex;align-items: center;justify-content: center;border-radius: 5px;background-color: #000000;color: #fff;font-weight: 400;">
					<i class="el-icon-goods" style="margin-top: 2px;"></i>
					<span style="margin-left: 2px;">
						{{$t('h.buyNow')}}
					</span>
				</div>
			</div> -->

			<div v-if="layoutConfig.right.detailModel == 'block'" style="margin-top: 10px;">
				<div v-if="layoutConfig.right.detailModel == 'block'" :style="{...getDetailBorder()}">
					<div v-if="layoutConfig.right.detailModel == 'block'" style="margin: auto;"
						:style="{width:layoutConfig.bto.widthType == 'px'?layoutConfig.bto.width + 'px':'100%'}">
						<div style="width: 100%;" :style="getBgStyle(layoutConfig.bto)">
							<div style="display: flex;justify-content: center;flex-direction: column;">
								<div style="width:100%" v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort"
									:key="sortIndex">
									<div style="margin-left: 10px;margin-top: 20px;"
										v-if="layoutConfig.right.showDetail && sortItem.value == 'detail'"
										:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}">
										{{$t('h.productDetail')}}
									</div>
									<div v-if="layoutConfig.right.showDetail && goodsData.product.description && sortItem.value == 'detail'"
										class="ql-container ql-snow" style="border:none;">
										<div class="ql-editor" style="width: fit-content;border:none; ">
											<div :style="{
												color:layoutConfig.right.tabColor.titColor
											}" v-html="goodsData.product.description">{{goodsData.product.description}}}
											</div>
										</div>
									</div>
									<div v-if="layoutConfig.right.showAttr && sortItem.value == 'attr'"
										:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
										style="margin-left: 10px;cursor: pointer;margin-top: 20px;">
										{{$t('h.attribute')}}
									</div>
									<div v-if="layoutConfig.right.showAttr && sortItem.value == 'attr'"
										style="width: 96%;font-size: 14px;margin-left: 2%;margin-top: 20px">
										<div style="max-width: 100%"
											v-for="(item,index) in goodsData.product.attributes" :key="index">
											<div style="border: solid 1px #c6c7c8;">
												<div :style="{
												 	color:layoutConfig.right.tabColor.titColor
												 }" style="padding: 6px;">
													{{item.attribute_group_name}}
												</div>
											</div>
											<div style="width: 100%;" v-for="(attrItem,attrIndex) in item.attributes">
												<div
													style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
													<div :style="{
														color:layoutConfig.right.tabColor.titColor
													}" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
														{{attrItem.attribute}}
													</div>
													<div :style="{
													 	color:layoutConfig.right.tabColor.titColor
													 }" style="padding-left: 20px;padding: 6px;">
														{{attrItem.attribute_value}}
													</div>
												</div>
											</div>
										</div>
									</div>

									<div v-if="layoutConfig.right.showComment && sortItem.value == 'coment'"
										:style="{color:layoutConfig.right.tabColor.titColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
										style="margin-left: 10px;cursor: pointer;margin-top: 20px;">
										{{$t('h.commentTit')}}
									</div>

									<div v-loading="commentCommentsLoad"
										style="width: 100%;min-height: 60px;margin-top: 20px;"
										v-if="layoutConfig.right.showComment && sortItem.value == 'coment'">


										<div style="margin: 20px;" v-if="goodsData.lcomment == 1"
											v-loading="loadingComment">
											<div v-for="(item,index) in evaluationForm" :key="index">
												<el-form :style="{
												 	'--formLabelColor':layoutConfig.right.tabColor.titColor
												 }" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
													class="demo-ruleForm">
													<el-form-item :label="$t('h.author')" prop="comment_user_name">
														<el-input show-word-limit :maxlength="50"
															:placeholder="$t('h.peleaseIpt')" :rows="1"
															v-model="item.comment_user_name"></el-input>
													</el-form-item>

													<el-form-item :label="$t('h.comment')" prop="content_text">
														<el-input show-word-limit :maxlength="350"
															:placeholder="$t('h.peleaseIpt')" :rows="3" type="textarea"
															v-model="item.content_text"></el-input>
													</el-form-item>
													<el-form-item v-if="goodsData.content_type == 2" style="width: 42%;"
														:label="$t('h.img')">
														<van-uploader max-count="5" :preview-full-image="false" @delete="
															(file,fileIndex)=>{
																deleteImgEvaluation(file,fileIndex,item)
															}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
																afterReadEvaluation(file, fileItem,item)
															}" />
													</el-form-item>
													<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
														<van-rate color="#ffaa00" touchable v-model="item.score" />
													</el-form-item>
												</el-form>
											</div>

											<div style="display: flex;align-items: center;">
												<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
													size="mini" >{{$t('h.cancel')}}</el-button> -->
												<el-button class="btn"
													style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
													size="mini" @click="upComments()">{{$t('h.confirm')}}</el-button>
											</div>
										</div>


										<el-empty v-if="commentdata && commentdata.length == 0"
											:description="$t('h.noContent')"></el-empty>
										<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
											style="width: 100%;display: flex;align-items: center;justify-content: center;">
											<el-button
												style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
												size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
										</div> -->
										<div v-if="commentdata " style="width: 96%;">
											<div v-for="(item,index) in commentdata" :key="index" style="width: 100%;">
												<div style="display: flex;width: 100%;align-items: center;">
													<div
														style="display: flex;flex-direction: column;align-items: center;margin-left: 10px;width: 120px;">
														<div v-if="item.avatar"
															style="width: 40px;height: 40px;border-radius: 100%;">
															<img v-if="item.avatar" :src="item.avatar"
																style="width: 40px;height: 40px;border-radius: 100%;" />
														</div>
														<div :style="{
															color:layoutConfig.right.tabColor.titColor
														}" style="font-size: 14px;color: #9fa19f;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;margin-left: 10px;">
															{{item.user_name}}
														</div>
													</div>
													<div style="margin-left: 20px;max-width: calc(100% - 120px);">
														<div :style="{
															color:layoutConfig.right.tabColor.titColor
														}" style="margin-top: 10px;font-size: 14px;color: #9fa19f;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
															<div>{{item.content}}</div>
														</div>
														<div style="margin-top: 10px;">
															<el-image v-for="(imgItem,imgIndex) in item.imgs"
																:key="imgIndex" style="width: 100px; height: 100px"
																:src="imgItem" :preview-src-list="item.imgs">
															</el-image>
														</div>
														<div style="margin-top: 10px
														;"><van-rate color="#ffaa00" touchable v-model="item.score" /></div>
														<div :style="{
														 	color:layoutConfig.right.tabColor.titColor
														 }" style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
															<div>{{item.created_at}}</div>
														</div>
													</div>
												</div>
												<div
													style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
												</div>
											</div>

											<div v-if="commentdata && commentdata.length > 0"
												style="width: 100vw;display: flex;justify-content: center;">
												<div style="display: flex;align-items: center;">
													<el-pagination :style="{
														'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
														'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
													}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}"
														style="margin: 10px;margin-top: 20px;"
														layout="prev, pager, next" :total="contentTotal">
													</el-pagination>
													<div :style="{
														color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
													}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="layoutConfig.right.detailModel == 'accordion'" style="margin-top: 10px;padding: 6px;"
				:style="{...getDetailBorder(),...getBgStyle(layoutConfig.bto)}">
				<el-collapse :style="{
				 	'--bgColor':layoutConfig.bto.singleBgColor?layoutConfig.bto.singleBgColor :'#fff',
				 	'--fontColor':layoutConfig.right.tabColor.titColor?layoutConfig.right.tabColor.titColor:'#000',
					'--collapseFontSize':layoutConfig.right.tabFontSize + 'px'
				 }" v-model="tabShow" accordion>
					<div style="width:100%" v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort"
						:key="sortIndex">
						<el-collapse-item v-show="layoutConfig.right.showDetail && sortItem.value == 'detail'"
							:title="$t('h.productDetail')" name="detail">
							<div class="ql-container ql-snow" style="border:none;">
								<div class="ql-editor" style="width: fit-content;border:none; ">
									<div v-html="goodsData.product.description">{{goodsData.product.description}}}</div>
								</div>
							</div>
						</el-collapse-item>
						<el-collapse-item v-show="layoutConfig.right.showAttr  && sortItem.value == 'attr'"
							:title="$t('h.attribute')" name="size">
							<div style="width: 100%;font-size: 14px;">
								<div style="width: 100%" v-for="(item,index) in goodsData.product.attributes"
									:key="index">
									<div style="border: solid 1px #c6c7c8;">
										<div style="padding: 6px;">
											{{item.attribute_group_name}}
										</div>
									</div>
									<div style="width: 100%;" v-for="(attrItem,attrIndex) in item.attributes">
										<div style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
											<div
												style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
												{{attrItem.attribute}}
											</div>
											<div style="padding-left: 20px;padding: 6px;">
												{{attrItem.attribute_value}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</el-collapse-item>

						<el-collapse-item style="border-bottom: solid 1px #cccccc;"
							v-show="layoutConfig.right.showComment && sortItem.value == 'coment'"
							:title="$t('h.commentTit')" name="comment">
							<div v-loading="commentCommentsLoad" style="width: 100%;min-height: 60px;">

								<div style="margin: 0px 20px;" v-if="goodsData.lcomment == 1"
									v-loading="loadingComment">
									<div v-for="(item,index) in evaluationForm" :key="index">
										<el-form :style="{
										'--formLabelColor':layoutConfig.right.tabColor.titColor
									}" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
											class="demo-ruleForm">
											<el-form-item :label="$t('h.author')" prop="comment_user_name">
												<el-input show-word-limit :maxlength="50"
													:placeholder="$t('h.peleaseIpt')" :rows="1"
													v-model="item.comment_user_name"></el-input>
											</el-form-item>

											<el-form-item :label="$t('h.comment')" prop="content_text">
												<el-input show-word-limit :maxlength="350"
													:placeholder="$t('h.peleaseIpt')" :rows="3" type="textarea"
													v-model="item.content_text"></el-input>
											</el-form-item>
											<el-form-item v-if="goodsData.content_type == 2" style="width: 42%;"
												:label="$t('h.img')">
												<van-uploader max-count="5" :preview-full-image="false" @delete="
					 							(file,fileIndex)=>{
					 								deleteImgEvaluation(file,fileIndex,item)
					 							}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
					 								afterReadEvaluation(file, fileItem,item)
					 							}" />
											</el-form-item>
											<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
												<van-rate color="#ffaa00" touchable v-model="item.score" />
											</el-form-item>
										</el-form>
									</div>

									<div style="display: flex;align-items: center;">
										<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
					 					size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
										<el-button class="btn"
											style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
											size="mini" @click="upComments()">{{$t('h.confirm')}}</el-button>
									</div>
								</div>



								<el-empty v-if="commentdata && commentdata.length == 0"
									:description="$t('h.noContent')"></el-empty>
								<!-- <div v-if="goodsData.lcomment == 1"
					 			style="width: 100%;display: flex;align-items: center;justify-content: center;">
					 			<el-button
					 				style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
					 				size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
					 		</div> -->
								<div v-if="commentdata " style="width: 100%;">
									<div v-for="(item,index) in commentdata" :key="index" style="width: 100%;">
										<div style="display: flex;align-items: center;">
											<div
												style="display: flex;flex-direction: column;align-items: center;width: 120px;">
												<div style="width: 40px;height: 40px;border-radius: 100%;">
													<img v-if="item.avatar" :src="item.avatar"
														style="width: 40px;height: 40px;border-radius: 100%;" />
												</div>
												<div :style="{
					 								color:layoutConfig.right.tabColor.titColor
					 							}" style="font-size: 14px;color: #9fa19f;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
													{{item.user_name}}
												</div>
											</div>
											<div style="margin-left: 20px;max-width: calc(100% - 120px);">
												<div :style="{
					 							color:layoutConfig.right.tabColor.titColor
					 						}" style="margin-top: 10px;font-size: 14px;color: #9fa19f;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
													<div>{{item.content}}</div>
												</div>
												<div style="margin-top: 10px;">
													<el-image v-for="(imgItem,imgIndex) in item.imgs" :key="imgIndex"
														style="width: 100px; height: 100px" :src="imgItem"
														:preview-src-list="item.imgs">
													</el-image>
												</div>
												<div style="margin-top: 10px
					 						;"><van-rate color="#ffaa00" touchable v-model="item.score" /></div>
												<div style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
													<div :style="{
					 								color:layoutConfig.right.tabColor.titColor
					 							}">{{item.created_at}}</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
										</div>
									</div>

									<div v-if="commentdata && commentdata.length > 0"
										style="width: 100%;display: flex;justify-content: center;">
										<div style="display: flex;align-items: center;">
											<el-pagination :style="{
											'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
											'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
										}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}" style="margin: 10px;"
												layout="prev, pager, next" :total="contentTotal">
											</el-pagination>
											<div :style="{
											color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
										}" style="font-size: 13px;">{{$t('h.allNum')}} {{contentTotal}} </div>
										</div>
									</div>
								</div>
							</div>
						</el-collapse-item>
					</div>
				</el-collapse>
			</div>

			<div style="width: 100%;margin: auto;">
				<div :style="{}" v-if="layoutConfig.right.detailModel == 'label'"
					style="width: calc(100% - 12px);word-wrap: break-word;overflow-wrap: break-word;white-space: normal;margin: auto;display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;margin-top: 15px;">
					<div :style="{
						 ...getBgBtoTit(layoutConfig.right.titSet)
					 }" style="display: flex;margin-top: 20px;width: 100%;justify-content: center;font-size: 18px;">
						<div style="" v-for="(sortItem,sortIndex) in layoutConfig.right.titSet.sort" :key="sortIndex">
							<div style="margin-left: 5px;margin-right: 5px;"
								v-if="layoutConfig.right.showDetail && sortItem.value == 'detail'"
								@click="tab = 'detail'"
								:style="{
								marginLeft:layoutConfig.right.detailMl + 'px',
								marginRight:layoutConfig.right.detailMl + 'px',
								color:tab == 'detail'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}">
								{{$t('h.productDetail')}}
							</div>
							<div v-if="layoutConfig.right.showAttr && sortItem.value == 'attr'" @click="tab = 'size'"
								:style="{
								marginLeft:layoutConfig.right.detailMl + 'px',
								marginRight:layoutConfig.right.detailMl + 'px',
								color:tab == 'size'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
								style="margin-left: 5px;margin-right: 5px;">
								{{$t('h.attribute')}}
							</div>

							<div v-if="layoutConfig.right.showComment && sortItem.value == 'coment'"
								@click="tab = 'comment';"
								:style="{
								marginLeft:layoutConfig.right.detailMl + 'px',
								marginRight:layoutConfig.right.detailMl + 'px',
								color:tab == 'comment'?layoutConfig.right.tabColor.titColor:layoutConfig.right.tabColor.titNoSelectColor,fontSize:layoutConfig.right.tabFontSize + 'px'}"
								style="margin-left: 5px;cursor: pointer;margin-right: 5px;">
								{{$t('h.commentTit')}}
							</div>
						</div>

					</div>
					<div style="margin-top: 20px;width: 100%;" :style="{...getDetailBorder()}">
						<div style="margin-top: 0px;width: calc(100% - 12px);margin: auto;"
							:style="getBgStyle(layoutConfig.bto)">
							<div style="width: 100%;display: flex;justify-content: center;">
								<div style="display: flex;margin-top: 10px;justify-content: center;width: 100%;">
									<div v-if="tab == 'detail' && goodsData.product.description && layoutConfig.right.showDetail"
										class="ql-container ql-snow" style="border:none;">
										<div class="ql-editor" style="width: fit-content;border:none; ">
											<div :style="{
											 	color:layoutConfig.right.tabColor.titColor
											 }" v-html="goodsData.product.description">
												{{goodsData.product.description}}}
											</div>
										</div>
									</div>
									<div v-if="tab == 'size' && layoutConfig.right.showAttr"
										style="width: 100%;font-size: 14px;">
										<div style="width: 100%" v-for="(item,index) in goodsData.product.attributes"
											:key="index">
											<div style="border: solid 1px #c6c7c8;">
												<div :style="{
												 	color:layoutConfig.right.tabColor.titColor
												 }" style="padding: 6px;">
													{{item.attribute_group_name}}
												</div>
											</div>
											<div style="width: 100%;" v-for="(attrItem,attrIndex) in item.attributes">
												<div
													style="display: flex;align-items: center;border: solid 1px #b1b1b1;">
													<div :style="{
														color:layoutConfig.right.tabColor.titColor
													}" style="border-right: solid 1px #b1b1b1 ;padding-right: 20px;padding: 6px;">
														{{attrItem.attribute}}
													</div>
													<div :style="{
													 	color:layoutConfig.right.tabColor.titColor
													 }" style="padding-left: 20px;padding: 6px;">
														{{attrItem.attribute_value}}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div v-loading="commentCommentsLoad" style="width: 100%;min-height: 60px;"
										v-if="tab == 'comment'">

										<div style="margin: 20px;" v-if="goodsData.lcomment == 1"
											v-loading="loadingComment">
											<div v-for="(item,index) in evaluationForm" :key="index">
												<el-form :style="{
												 	'--formLabelColor':layoutConfig.right.tabColor.titColor
												 }" label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm" label-width="100px"
													class="demo-ruleForm">
													<el-form-item :label="$t('h.author')" prop="comment_user_name">
														<el-input show-word-limit :maxlength="50"
															:placeholder="$t('h.peleaseIpt')" :rows="1"
															v-model="item.comment_user_name"></el-input>
													</el-form-item>

													<el-form-item :label="$t('h.comment')" prop="content_text">
														<el-input show-word-limit :maxlength="350"
															:placeholder="$t('h.peleaseIpt')" :rows="3" type="textarea"
															v-model="item.content_text"></el-input>
													</el-form-item>
													<el-form-item v-if="goodsData.content_type == 2" style="width: 42%;"
														:label="$t('h.img')">
														<van-uploader max-count="5" :preview-full-image="false" @delete="
															(file,fileIndex)=>{
																deleteImgEvaluation(file,fileIndex,item)
															}" v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
																afterReadEvaluation(file, fileItem,item)
															}" />
													</el-form-item>
													<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
														<van-rate color="#ffaa00" touchable v-model="item.score" />
													</el-form-item>
												</el-form>
											</div>
											<div style="display: flex;align-items: center;">
												<!-- <el-button class="btn" style="width: 160px;background-color: #ffffff;color: #000000;padding: 10px;border: solid 1px #9fa19f;"
													size="mini" @click="evaluationDialogVisible = false">{{$t('h.cancel')}}</el-button> -->
												<el-button class="btn"
													style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
													size="mini" @click="upComments()">{{$t('h.confirm')}}</el-button>
											</div>
										</div>
										<el-empty v-if="commentdata && commentdata.length == 0"
											:description="$t('h.noContent')"></el-empty>
										<!-- <div v-if="goodsData.lcomment == 1 && !evaluationDialogVisible"
											style="width: 100%;display: flex;align-items: center;justify-content: center;">
											<el-button
												style="width: 180px;margin: 10px;background-color: #ff5500;color: #fff;padding: 10px;"
												size="mini" @click="addEvaluation">{{$t('h.evaluation')}}</el-button>
										</div> -->
										<div v-if="commentdata " style="width: 100%;margin-top: 10px;">
											<div v-for="(item,index) in commentdata" :key="index" style="width: 100%;">
												<div style="display: flex;width: 100%;">
													<div
														style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: 120px;">
														<div v-if="item.avatar"
															style="width: 40px;height: 40px;border-radius: 100%;">
															<img v-if="item.avatar" :src="item.avatar"
																style="width: 40px;height: 40px;border-radius: 100%;" />
														</div>
														<div :style="{
															color:layoutConfig.right.tabColor.titColor
														}" style="font-size: 14px;color: #9fa19f;margin-top: 10px;white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;margin-left: 10px;">
															{{item.user_name}}
														</div>
													</div>
													<div
														style="margin-left: 20px;max-width: calc(100% - 120px);white-space:normal;word-wrap: break-word;hyphens: auto;word-break: break-all;">
														<div style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
															<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}">{{item.content}}</div>
														</div>
														<div style="margin-top: 10px;">
															<el-image v-for="(imgItem,imgIndex) in item.imgs"
																:key="imgIndex" style="width: 60px; height: 60px"
																:src="imgItem" :preview-src-list="item.imgs">
															</el-image>
														</div>
														<div style="margin-top: 10px
														;"><van-rate color="#ffaa00" touchable v-model="item.score" /></div>
														<div style="margin-top: 10px;font-size: 14px;color: #9fa19f;">
															<div :style="{
																color:layoutConfig.right.tabColor.titColor
															}">{{item.created_at}}</div>
														</div>
													</div>
												</div>
												<div
													style="width: 100%;height: 1px;background-color: #cdcfcd;margin-top: 10px;margin-bottom: 10px;">
												</div>
											</div>

											<div v-if="commentdata && commentdata.length > 0"
												style="width: 100%;display: flex;justify-content: center;">
												<el-pagination :style="{
													'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
													'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
												}" @current-change="(e)=>{page = e;getL_commentCommentsData(goodsData.product.id)}" style="margin: 10px;"
													layout="prev, pager, next" :total="contentTotal">
												</el-pagination>

											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div style="height: 68px;width: 10px;"></div>
		</div>
		<div style="position: absolute;left: 0px;" v-if="layoutConfig.right.phoneBtnP == 'bto'">
			<div :style="{bottom:type != 'design'?'0px':'78px',width:type != 'design'?'100%': '100%',marginLeft:type != 'design'?'0px':'1px',borderRadius:type != 'design'?'none':'0px 0px 0px 0px'}"
				v-if="equipment == 'phone'"
				style="position: fixed;background-color: #ffffff;font-size: 13px;z-index: 100000;max-width: 407.2px;">
				<div style="display: flex;align-items: center;justify-content: space-around;width:100%">
					<div v-if="layoutConfig.right.showAddNum"
						style="display: flex;height: 100%;width: 20%;margin: 5px;">
						<input v-model="order.num" style="width: 70%;border: solid 1px #d5d5d5 ;min-height: 42px;"
							type="text" class="proxy-quantity-input" onkeyup="this.value=this.value.replace(/\D/g,'')">
						<div
							style="display: flex;flex-direction: column;height: 100%;justify-content: space-between;width: 30%;">
							<div @click="add" class="chg-bi-chevron-up"
								style="display: flex;align-items: center;justify-content: center;border: solid 1px #d5d5d5 ;cursor: pointer;width: 100%;height: 21px;">
								<i class="el-icon-arrow-up"></i>
							</div>
							<div @click="sub" class="chg-bi-chevron-down"
								style="display: flex;align-items: center;justify-content: center;border: solid 1px #d5d5d5 ;cursor: pointer;width: 100%;height: 21px;">
								<i class="el-icon-arrow-down"></i>
							</div>
						</div>
					</div>
					<div v-if="layoutConfig.right.showAddCart" @click="addCarts" class="add-cart"
						style="width: fit-content;height: 34px;padding: 4px 6px;border: solid 1px #000000;display: flex;align-items: center;justify-content: center;border-radius: 5px;margin-left: 10px;font-weight: 400;margin: 5px;">
						<i class="el-icon-shopping-cart-2" style="margin-top: 2px;"></i>
						<span style="margin-left: 2px;">
							{{$t('h.addCart')}}
						</span>
					</div>
					<div v-if="layoutConfig.right.showBuyNow" @click="buyNow"
						style="width: fit-content;height: 34px;padding: 4px 6px;border: solid 1px #000000;display: flex;align-items: center;justify-content: center;border-radius: 5px;margin-left: 10px;background-color: #000000;color: #fff;font-weight: 400;margin: 5px;">
						<i class="el-icon-goods" style="margin-top: 2px;"></i>
						<span style="margin-left: 2px;">
							{{$t('h.buyNow')}}
						</span>
					</div>
					<div v-if="layoutConfig.right.showLove" @click="collect"
						style="margin-left: 15px;font-size: 26px;margin: 5px;">
						<i v-if="!isCollct" class="el-icon-star-off"></i>
						<i v-if="isCollct" class="el-icon-star-on"></i>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="" :visible.sync="dialogVisible" :width="equipment == 'phone'?'90%':'60%'"
			:before-close="()=>{dialogVisible = false}">
			<div v-loading="iframeLogin">
				<iframe v-if="dialogVisible" id="iframe" style="width: 100%;min-height: 650px;" ref="iframe"
					src="/login?iframe=true" frameborder="0" scrolling="auto" @load="iframeLogin = false"></iframe>
			</div>
		</el-dialog>
		<!-- <el-dialog :title="$t('h.evaluation')" :width="equipment == 'phone' ?'96%':'60%'"
			:before-close="()=>{evaluationDialogVisible = false}" :visible.sync="evaluationDialogVisible">
			<div v-loading="loadingComment">
				<div v-for="(item,index) in evaluationForm" :key="index">
					<el-form label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm"
						label-width="100px" class="demo-ruleForm">
						<el-form-item :label="$t('h.author')" prop="comment_user_name">
							<el-input show-word-limit :maxlength="50" :placeholder="$t('h.peleaseIpt')" :rows="2"
								type="textarea" v-model="item.comment_user_name"></el-input>
						</el-form-item>

						<el-form-item :label="$t('h.comment')" prop="content_text">
							<el-input show-word-limit :maxlength="350" :placeholder="$t('h.peleaseIpt')" :rows="2"
								type="textarea" v-model="item.content_text"></el-input>
						</el-form-item>
						<el-form-item v-if="goodsData.content_type == 2" style="width: 42%;" :label="$t('h.img')">
							<van-uploader max-count="5" :preview-full-image="false"
								@delete="deleteImgEvaluation($event,item.fileList)" v-model="item.fileList" multiple
								:after-read="(file, fileItem)=>{
									afterReadEvaluation(file, fileItem,item)
								}" />
						</el-form-item>
						<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
							<van-rate color="#ffaa00" touchable v-model="item.score" />
						</el-form-item>
					</el-form>
				</div>
				<el-button class="btn" style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
					size="mini" @click="upComments()">{{$t('h.confirm')}}</el-button>
			</div>
		</el-dialog> -->
	</div>
</template>
<script>
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import {
		getProductsAutocomplete,
		getproductsDetail,
		getDesignProductsDetail,
		getAccountAddCarts,
		getAccountCollect,
		getL_commentComments,
		l_commentComments,
		getl_comment_upload
	} from '../../api/all.js'
	import "quill/dist/quill.core.css"; // import styles
	import "quill/dist/quill.snow.css"; // for snow theme
	import "quill/dist/quill.bubble.css"; // for bubble theme
	import PreciseDragScroll from './PreciseDragScroll.vue'
	import imgZoom from './imgZoom.vue';
	import facebookPixel from '../../facebookPixel'

	import lodash from 'lodash';
	export default {
		components: {
			PreciseDragScroll,
			imgZoom
		},

		props: {
			placeNavHeight: {
				type: Number,
				default: 0
			},
			guides: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
		watch: {
			selectdItem: {
				immediate: true,
				deep: true,
				handler: function(newVal, oldVal) {
					console.log('selectdItemselectdItemselectdItem1111', newVal)
					this.layoutConfig = newVal.compontChildren[0].layoutConfig
					if (this.layoutConfig.right.showDetail) {
						this.tab = 'detail'
					} else {
						this.tab = 'size'
					}
				}
			},
		},
		computed: {
			...mapState("lowCodeStore", ['goodsConfig', 'classifyListPreview']),
			imageStyle() {
				return {
					transform: this.isHovered ? 'scale(1.2)' : 'scale(1)',
					transition: 'transform 0.3s ease-in-out',
				};
			},
			...mapState("lowCodeStore", ['cartNum']),
		},
		updated() {
			if (this.equipment == 'phone') {
				this.cWidth = document.getElementById('carousel').offsetWidth
			}
		},
		data() {
			return {
				timeIframe:null,
				videoPlay: false,
				video: "",
				content_type: 0,
				evaluationRules: {
					content_text: [{
						required: true,
						message: this.$t('h.peleaseIpt'),
						trigger: 'blur'
					}],
					comment_user_name: [{
						required: true,
						message: this.$t('h.peleaseIpt'),
						trigger: 'blur'
					}]
				},
				evaluationForm: [],
				loadingComment: false,
				evaluationDialogVisible: false,
				contentTotal: 0,
				flieListd: [],
				cWidth: 407,
				initialIndex: 0,
				loading: false,
				selectImgId: "",
				tabShow: "",
				enterSizeItem: null,
				isCollct: false,
				iframeLogin: false,
				dialogVisible: false,
				selectImg: "",
				tab: "detail",
				order: {
					num: 1
				},
				sku: {},
				selectIndexs: [],
				select: {},
				goodsData: null,
				isHovered: false,
				sort: ['1', '2'],
				sort1: ['2', '1'],
				layoutConfig: {},
				page: 1,
				commentCommentsLoad: false,
				commentdata: null,
				selectOptions: []
			}
		},
		async mounted() {
			let that = this
			const iframe = document.getElementById('myIframe');
			window.addEventListener('message', (e) => {
				console.log('messagemessage123', e)
				if (e.data.type === 'accordionToggle') {
					// that.onIframeLoad()
					// const iframe = that.$refs.iframe;
					// const height = (e.data.height + 100) + 'px'
					// iframe.style.height = height
				}
			});


			if (this.goodsConfig.length > 0) {
				console.log('classifyListPreview', this.classifyListPreview)
				if (this.classifyListPreview.length > 0) {

					this.classifyListPreview.forEach(item => {
						if (item.name == '商品分类') {
							this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig = lodash.cloneDeep(
								item.children[0].children[0].compontChildren[0].layoutConfig.classFiyConfig
							)
						}
					})

					// this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig = this.classifyListPreview[0].compontChildren[0].layoutConfig.classFiyConfig
				}
				this.selectdItem.compontChildren[0].layoutConfig.goodsConfig = lodash.cloneDeep(this.goodsConfig[0])
				this.$forceUpdate()
			}

			if (!this.layoutConfig.right.selectTabSet) {
				this.$set(this.layoutConfig.right, 'selectTabSet', {
					hoverBg: {
						fontColor: "#000",
						bgtype: "color", // color gradient img
						bgGradient: "",
						color: "#fff",
					},
					selectBg: {
						fontColor: "#000",
						bgtype: "color", // color gradient img
						bgGradient: "",
						color: "#fff",
					},
					defaultBg: {
						fontColor: "#595959",
						bgtype: "color", // color gradient img
						bgGradient: "",
						color: "#fff",
					}

				})
			}

			if (!this.layoutConfig.right.showSelectImg) {
				this.$set(this.layoutConfig.right, 'showSelectImg', false)
			}

			if (!this.layoutConfig.right.selectImgBorderRadius) {
				this.$set(this.layoutConfig.right, 'selectImgBorderRadius', [0, 0, 0, 0])
			}

			if (!this.layoutConfig.right.showSelectImgSet) {
				this.$set(this.layoutConfig.right, 'showSelectImgSet', {
					width: 60,
					height: 60,
					phoneWidth: 40,
					phoneHeight: 40,
					mode: 'cover'
				})
			}


			if (!this.layoutConfig.right.phoneBtnP) {
				this.$set(this.layoutConfig.right, 'phoneBtnP', 'top')
			}

			if (!this.layoutConfig.right.detailMl) {
				this.$set(this.layoutConfig.right, 'detailMl', 5)
			}

			if (!this.layoutConfig.right.priceShow) {
				this.$set(this.layoutConfig.right, 'priceShow', {
					price: true,
					originalPrice: true
				})
			}

			if (!this.layoutConfig.right.rightBtn) {
				this.$set(this.layoutConfig.right, 'rightBtn', {
					addNumFull: false,
					addCartFull: false,
					buyNowFull: false,
					loveFull: false,
					addCartWidth: 160,
					buyNowWidth: 160,
					phoneAddNumFull: false,
					phoneAddCartFull: false,
					phoneBuyNowFull: false,
					phoneLoveFull: false,
					phoneAddCartWidth: 105,
					phoneBuyNowWidth: 105,
				})
			}

			if (!this.layoutConfig.right.rightBtnColor) {
				this.$set(this.layoutConfig.right, 'rightBtnColor', {
					addCart: {
						color: "#000",
						bg: {
							bgtype: "color", // color gradient img
							bgGradient: "",
							color: "#fff",
						},
						border: {
							borderRadius: [0, 0, 0, 0],
							borderSize: [0, 0, 0, 0],
							radius: 0,
							type: "solid",
							px: 0,
							color: "#000"
						},
					},
					buyNow: {
						color: "#fff",
						bg: {
							bgtype: "color", // color gradient img
							bgGradient: "",
							color: "#000",
						},
						border: {
							borderRadius: [0, 0, 0, 0],
							borderSize: [0, 0, 0, 0],
							radius: 0,
							type: "solid",
							px: 0,
							color: "#000"
						},
					},
					love: {
						bg: {
							color: "#000",
						},
					}
				})
			}

			if (!this.layoutConfig.right.tabColor) {
				this.$set(this.layoutConfig.right, 'tabColor', {
					titColor: "#000",
					titNoSelectColor: "#888888"
				})
				console.log('this.layoutConfig.right', this.layoutConfig.right)
			}

			if (!this.layoutConfig.right.tabFontSize) {
				this.$set(this.layoutConfig.right, 'tabFontSize', 16)
			}

			if (!this.layoutConfig.right.quantityFont) {
				this.$set(this.layoutConfig.right, 'quantityFont', {
					color: "#a3a3a3",
					fontSize: 16,
					fontFamily: "",
					titColor: "#000",
					titFontSize: 16,
					titFontFamily: ""
				})

			}
			if (!this.layoutConfig.right.brandFont) {
				this.$set(this.layoutConfig.right, 'brandFont', {
					color: "#a3a3a3",
					fontSize: 16,
					fontFamily: "",
					titColor: "#000",
					titFontSize: 16,
					titFontFamily: ""
				})
			}
			if (!this.layoutConfig.right.skuFont) {
				this.$set(this.layoutConfig.right, 'skuFont', {
					color: "#a3a3a3",
					fontSize: 16,
					fontFamily: "",
					titColor: "#000",
					titFontSize: 16,
					titFontFamily: ""
				})
			}
			if (!this.layoutConfig.right.modelFont) {
				this.$set(this.layoutConfig.right, 'modelFont', {
					color: "#a3a3a3",
					fontSize: 16,
					fontFamily: "",
					titColor: "#000",
					titFontSize: 16,
					titFontFamily: ""
				})
			}
			if (!this.layoutConfig.right.htmlCode) {
				this.$set(this.layoutConfig.right, 'htmlCode', '')
			}

			if (!this.layoutConfig.right.titSet) {
				this.$set(this.layoutConfig.right, 'titSet', {
					bg: {
						bgtype: "color", // color gradient img
						bgGradient: "",
						color: "",
					},
					sort: [{
							value: 'detail',
							label: "详情"
						},
						{
							value: 'attr',
							label: "属性"
						},
						{
							value: 'coment',
							label: "评论"
						}
					],
					position: "1",
					padding: [0, 0, 0, 0]
				})
			}

			if (this.layoutConfig.right.titSet) {
				let item = this.layoutConfig.right.titSet.sort[0]
				if (item.value == 'detail') {
					this.tab = 'detail'
				}
				if (item.value == 'attr') {
					this.tab = 'size'
				}
				if (item.value == 'coment') {
					this.tab = 'comment'
				}
			}


			this.cWidth = 407
			console.log('cWidthcWidthcWidth', this.cWidth)
			window.addEventListener('message', this.handleMessage);
			let wsid = this.$cookies.get("wsid")
			try {
				this.loading = true
				let data;
				if (this.type != 'build') {

					if (process.env.NODE_ENV == 'development') {
						// data = await getDesignProductsDetail({
						// 	product_id: 3628,
						// 	wsid
						// })
						let goodsList = await getProductsAutocomplete({
							wsid
						})
						if (goodsList.data.data.length == 0) {
							this.$message.error('商品列表为空')
							return
						}
						console.log('goodsList', goodsList)
						data = await getDesignProductsDetail({
							product_id: goodsList.data.data[0].id,
							wsid
						})
					} else {
						let goodsList = await getProductsAutocomplete({
							wsid
						})
						if (goodsList.data.data.length == 0) {
							this.loading = false
							this.$message.error('商品列表为空')
							return
						}
						console.log('goodsList', goodsList)
						data = await getDesignProductsDetail({
							product_id: goodsList.data.data[0].id,
							wsid
						})
					}
				} else {
					data = this.selectdItem.compontChildren[0].data.dataDetail
					console.log('selectdItemgetproductsDetail', this.selectdItem)
					console.log('selectdItemgetproductsDetaildata', data)
				}

				this.goodsData = data.data.data
				if (this.goodsData.product.in_wishlist > 0) {
					this.isCollct = true
				}
				this.goodsData.product.variables.forEach((item, index) => {
					if (item.values.length > 0) {
						this.select['sku' + index + item.name] = item.values[0]
						this.select['sku' + index + item.name].index = 0
					}
					this.selectIndexs.push(0)
				})

				if (this.goodsData.product.options && this.goodsData.product.options.length > 0) {
					this.goodsData.product.options.forEach((item, index) => {
						this.selectOptions.push({
							option_name: item.option_name,
							index: index,
							value:item.values[0],
						})
					})
				}


				console.log('this.select', this.select)
				console.log('this.goodsData.product.variables', this.goodsData.product.variables)
				this.goodsData.product.skus.forEach(item => {
					if (item.variants.join('') == this.selectIndexs.join('')) {
						this.sku = item
					}
				})
				if (this.goodsData.product.images.length > 0) {
					this.selectImg = this.goodsData.product.images[0].preview
				}
				if (this.sku.images.length > 0) {
					this.selectImg = this.sku.images[0].preview
				}
				this.getL_commentCommentsData(this.goodsData.product.id)
				this.loading = false
				this.addEvaluation()
			} catch (e) {
				console.log('e', e)
				this.loading = false
			}


			// const parent = document.querySelector('.parent');
			// const child = document.querySelector('.child');
			// console.log('offsetWidthoffsetWidth',parent)
			// child.style.maxHeight = `${parent.offsetWidth}px`;

			// // 添加窗口大小变化监听
			// window.addEventListener('resize', () => {
			//   child.style.maxHeight = `${parent.offsetWidth}px`;
			// });

		},

		beforeDestroy() {
			window.removeEventListener('message', this.handleMessage);
		},
		methods: {
			getAddOstionPriceAll(){
				let price = 0
				this.selectOptions.forEach(itemOption => {
					price = parseFloat(itemOption.value.price) + price
				})
				return price
			},
			getAddOstionPrice(item,index){
				let price = '0.00'
				this.selectOptions.forEach(itemOption => {
					if (itemOption.option_name == item.option_name) {
						price = itemOption.value.price
					}
				})
				return price
			},
			getBorderRadiusCustomize(item, index) {
				let style = {}
				style.borderRadius =
					`${this.layoutConfig.right.optionBorderRadius[0]}px ${this.layoutConfig.right.optionBorderRadius[1]}px ${this.layoutConfig.right.optionBorderRadius[2]}px ${this.layoutConfig.right.optionBorderRadius[3]}px`
				// console.log('getBorderRadius', style)
				return style
			},
			getBorderSizeCustomize(item, index, value, valueIndex) {
				let style = {}
				if (this.layoutConfig.right.isHover) {
					if (this.layoutConfig.right.hoverBorderType != '') {
						if (this.enterSizeItem && this.enterSizeItem.item.option_name == item.option_name && this
							.enterSizeItem.index == index && this.enterSizeItem.value.id == value.id) {
							style.borderTop =
								`${this.layoutConfig.right.hoverBorderType} ${this.layoutConfig.right.optionBorderSize[0]}px ${this.layoutConfig.right.hoverBorderColor}`
							style.borderLeft =
								`${this.layoutConfig.right.hoverBorderType} ${this.layoutConfig.right.optionBorderSize[1]}px ${this.layoutConfig.right.hoverBorderColor}`
							style.borderBottom =
								`${this.layoutConfig.right.hoverBorderType} ${this.layoutConfig.right.optionBorderSize[2]}px ${this.layoutConfig.right.hoverBorderColor}`
							style.borderRight =
								`${this.layoutConfig.right.hoverBorderType} ${this.layoutConfig.right.optionBorderSize[3]}px ${this.layoutConfig.right.hoverBorderColor}`
							return style

							// return this.layoutConfig.right.hoverBorderType + ' 1px ' + this.layoutConfig.right.hoverBorderColor
						}
					}
				}
				if (this.layoutConfig.right.optionBorderType != '') {

					let isSelect = false
					this.selectOptions.forEach(itemOption => {
						if (itemOption.option_name == item.option_name && itemOption.index == index && itemOption.value
							.id == value.id) {
							isSelect = true
						}
					})
					// if(this.selectOptions.option_name == item.option_name && this.selectOptions.index == index){
					// 	isSelect = true
					// }

					if (isSelect) {

						style.borderTop =
							`${this.layoutConfig.right.optionBorderType} ${this.layoutConfig.right.optionBorderSize[0]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderLeft =
							`${this.layoutConfig.right.optionBorderType} ${this.layoutConfig.right.optionBorderSize[1]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderBottom =
							`${this.layoutConfig.right.optionBorderType} ${this.layoutConfig.right.optionBorderSize[2]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderRight =
							`${this.layoutConfig.right.optionBorderType} ${this.layoutConfig.right.optionBorderSize[3]}px ${this.layoutConfig.right.optionBorderColor}`
						return style
						// return this.layoutConfig.right.optionBorderType + ' 1px ' + this.layoutConfig.right.optionBorderColor
					} else {
						style.borderTop =
							`dashed ${this.layoutConfig.right.optionBorderSize[0]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderLeft =
							`dashed ${this.layoutConfig.right.optionBorderSize[1]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderBottom =
							`dashed ${this.layoutConfig.right.optionBorderSize[2]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderRight =
							`dashed ${this.layoutConfig.right.optionBorderSize[3]}px ${this.layoutConfig.right.optionBorderColor}`
						return style
						// return 'dashed 1px ' + this.layoutConfig.right.optionBorderColor
					}
				} else {
					return 'none'
				}


			},
			getSelectTabColorCustomize(select, item, index, value, valueIndex) {
				if (this.enterSizeItem && this.enterSizeItem.item.option_name == item.option_name && this.enterSizeItem
					.index == index && this.enterSizeItem.value.id == value.id) {
					if (this.layoutConfig.right.selectTabSet.hoverBg.fontColor) {
						return this.layoutConfig.right.selectTabSet.hoverBg.fontColor
					}
				}
				let isSelect = false
				this.selectOptions.forEach(itemOption => {
					if (itemOption.option_name == item.option_name && itemOption.index == index && itemOption.value
						.id == value.id) {
						isSelect = true
					}
				})
				
				
				if (isSelect) {
					// 选中的颜色
					return this.layoutConfig.right.selectTabSet.selectBg.fontColor
				
				} else {
					return this.layoutConfig.right.selectTabSet.defaultBg.fontColor
				}

			},
			
			changeOptionsSelect(item, index, value, valueIndex){
				this.selectOptions.forEach(itemOption => {
					if (itemOption.option_name == item.option_name && itemOption.index == index) {
						itemOption.value = {
							...value
						}
					}
				})
			},

			getSelectTabBgColorCustomize(select, item, index, value, valueIndex) {
				if (this.enterSizeItem) {
					console.log('this.enterSizeItem', this.enterSizeItem)
					console.log('item', item)
					console.log('value', value)
				}
				if (this.enterSizeItem && this.enterSizeItem.item.option_name == item.option_name && this.enterSizeItem
					.index == index && this.enterSizeItem.value.id == value.id) {
					let style = {}
					if (this.layoutConfig.right.selectTabSet.hoverBg.bgtype == 'color') {
						if (this.layoutConfig.right.selectTabSet.hoverBg.color) {
							style.backgroundColor = this.layoutConfig.right.selectTabSet.hoverBg.color
							return style
						}
					} else {
						if (this.layoutConfig.right.selectTabSet.hoverBg.bgGradient) {
							style = {
								...this.cssStringToObject(this.layoutConfig.right.selectTabSet.hoverBg.bgGradient)
							}
						}
						return style
					}
				}

				let isSelect = false
				console.log('this.selectOptions',this.selectOptions)
				this.selectOptions.forEach(itemOption => {
					if (itemOption.option_name == item.option_name && itemOption.index == index && itemOption.value
						.id == value.id) {
						isSelect = true
					}
				})
				// if(this.selectOptions.option_name == item.option_name && this.selectOptions.index == index){
				// 	isSelect = true
				// }


				// this.selectOptions.forEach(itemOption=>{
				// 	if(itemOption.option_name == item.option_name && itemOption.index == index){
				// 		isSelect = true
				// 	}
				// })

				console.log('selectOptions', this.selectOptions)
				console.log('isSelect123', isSelect)

				if (isSelect) {
					// 选中的颜色

					let style = {}
					if (this.layoutConfig.right.selectTabSet.selectBg.bgtype == 'color') {
						style.backgroundColor = this.layoutConfig.right.selectTabSet.selectBg.color
					} else {
						style = {
							...this.cssStringToObject(this.layoutConfig.right.selectTabSet.selectBg.bgGradient)
						}
					}
					return style

				} else {

					let style = {}
					if (this.layoutConfig.right.selectTabSet.defaultBg.bgtype == 'color') {
						style.backgroundColor = this.layoutConfig.right.selectTabSet.defaultBg.color
					} else {
						style = {
							...this.cssStringToObject(this.layoutConfig.right.selectTabSet.defaultBg.bgGradient)
						}
					}
					return style
				}
			},


			getSelectTabBgColor(select, item, index, value) {
				if (this.enterSizeItem && this.enterSizeItem.name == value.name) {
					let style = {}
					if (this.layoutConfig.right.selectTabSet.hoverBg.bgtype == 'color') {
						if (this.layoutConfig.right.selectTabSet.hoverBg.color) {
							style.backgroundColor = this.layoutConfig.right.selectTabSet.hoverBg.color
							return style
						}
					} else {
						if (this.layoutConfig.right.selectTabSet.hoverBg.bgGradient) {
							style = {
								...this.cssStringToObject(this.layoutConfig.right.selectTabSet.hoverBg.bgGradient)
							}
						}
						return style
					}
				}
				if (select['sku' + index + item.name].name == value.name) {
					// 选中的颜色

					let style = {}
					if (this.layoutConfig.right.selectTabSet.selectBg.bgtype == 'color') {
						style.backgroundColor = this.layoutConfig.right.selectTabSet.selectBg.color
					} else {
						style = {
							...this.cssStringToObject(this.layoutConfig.right.selectTabSet.selectBg.bgGradient)
						}
					}
					return style

				} else {

					let style = {}
					if (this.layoutConfig.right.selectTabSet.defaultBg.bgtype == 'color') {
						style.backgroundColor = this.layoutConfig.right.selectTabSet.defaultBg.color
					} else {
						style = {
							...this.cssStringToObject(this.layoutConfig.right.selectTabSet.defaultBg.bgGradient)
						}
					}
					return style
				}
			},
			getSelectTabColor(select, item, index, value) {
				if (this.enterSizeItem && this.enterSizeItem.name == value.name) {
					if (this.layoutConfig.right.selectTabSet.hoverBg.fontColor) {
						return this.layoutConfig.right.selectTabSet.hoverBg.fontColor
					}
				}
				if (select['sku' + index + item.name].name == value.name) {
					// 选中的颜色
					return this.layoutConfig.right.selectTabSet.selectBg.fontColor

				} else {
					return this.layoutConfig.right.selectTabSet.defaultBg.fontColor
				}

			},
			getBgBtoTit(item) {
				let style = {}
				if (item.bg.bgtype == 'color') {
					if (item.bg.color != '') {
						style.backgroundColor = item.bg.color
					}
				} else {
					if (item.bg.bgGradient != '') {
						style = {
							...this.cssStringToObject(item.bg.bgGradient)
						}
					}
				}
				return style
			},
			onIframeLoad() {
				// console.log('this.$refs.iframe', )
				const iframe = this.$refs.iframe;
				let that = this
				this.timeIframe = setInterval(() => {
					try{
						iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
					}catch(e){
						clearInterval(that.timeIframe)
					}
				}, 0)
				
				
				
			},
			isMp4(url) {
				console.log('isMp4url', url)
				console.log('isMp4url', url.substring(url.lastIndexOf(".")) == '.mp4')


				if (url.substring(url.lastIndexOf(".")) == '.mp4') {
					return true
				} else {
					return false
				}
			},
			playVideo() {
				this.videoPlay = true
				this.$nextTick(() => {
					var video = document.getElementById("myVideo");
					video.play();
				})


			},
			getBtnBgColor(item) {
				let style = {}
				if (item.bg.bgtype == 'color') {
					style.backgroundColor = item.bg.color
				} else {
					style = {
						...this.cssStringToObject(item.bg.bgGradient)
					}
				}
				return style
			},

			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},


			deleteImgEvaluation(file, fileIndex, item) {

				item.imgs.splice(fileIndex.index, 1)
				console.log(file, fileIndex, item)
				// let arr = []
				// this.fileEvaluationList.forEach(item => {
				// 	arr.push(item.url)
				// })
				// this.ruleForm.images = arr
			},
			addEvaluation() {

				this.evaluationForm = []

				this.evaluationForm.push({
					show_product_id: false,
					ip: "",
					comment_user_name: "",
					score: 5,
					content_text: "",
					zone: "",
					videos: [],
					imgs: [],
					order_id: 0,
					order_product_id: 0,
					product_name: this.goodsData.product.name,
					product_id: this.goodsData.product.id,
					fileList: [],
					id: 0
				})

				this.evaluationDialogVisible = true


			},
			async afterReadEvaluation(file, fileItem, item) {
				this.loadingComment = true
				try {
					const formData = new FormData();
					formData.append('file', file.file)
					formData.append('type', 'rma')

					let imgUpload = await getl_comment_upload({
						formData
					})
					// file.url = imgUpload.data.data.value
					item.imgs.push({
						response: imgUpload.data,
						...imgUpload.data
					})
					console.log('this.evaluationForm.images', item)
					this.loadingComment = false
				} catch (e) {
					console.log('catche', e)
					this.loadingComment = false
					// this.loading = false
				}


				// 	console.log('file', file)
			},

			async upComments() {
				let valid = true
				this.$refs['evaluationForm'].forEach(item => {
					item.validate((valid) => {
						if (valid) {

						} else {
							valid = false
							return false
						}
					})
				})

				let arr = []
				this.evaluationForm.forEach(item => {
					if (item.content_text == '') {
						valid = false
					}
					arr.push({
						id: 0,
						comment_user_name: item.comment_user_name,
						show_product_id: false,
						ip: item.ip,
						score: item.score,
						content_text: item.content_text,
						zone: item.zone,
						videos: item.videos,
						imgs: item.imgs,
						order_id: item.order_id,
						order_product_id: item.order_product_id,
						product_id: item.product_id,
					})
				})
				if (valid) {
					try {
						this.loadingComment = true
						let data = await l_commentComments({
							comments: arr
						})
						this.loadingComment = false
						this.evaluationDialogVisible = false
						this.addEvaluation()
						console.log('data', data)
						this.getL_commentCommentsData(this.goodsData.product.id)
					} catch (e) {
						this.loadingComment = false
					}

				}


			},



			getImg(imgs) {
				let arr = []
				imgs.forEach(item => {
					arr.push({
						url: item
					})
				})
				console.log('arrarr', arr)
				return arr
			},
			async getL_commentCommentsData(id) {
				console.log('getL_commentCommentsData', id)
				try {
					this.commentCommentsLoad = true
					let data = await getL_commentComments({
						product_id: id,
						page: this.page

					})
					console.log('commentdata', data)
					this.commentdata = data.data.productsComments.data
					this.contentTotal = data.data.productsComments.total
					this.commentCommentsLoad = false
				} catch (e) {
					this.commentCommentsLoad = false
				}

			},

			...mapMutations("lowCodeStore", ["setSelectdItem", "setCenterList", "setList"]),
			handleMessage(event) {
				let that = this
				console.log('eventeventevent', event)

				if (event && event.data.type == 'apiLoginResponse' && event.data.data.status == "success") {
					that.dialogVisible = false
					localStorage.setItem('address', JSON.stringify(event.data.data.data))
					// that.$message.success(event.data.data.message)
				}
			},
			getAspectRatioPhone(item) {
				if (item.preViewImgPhoneWidth == item.preViewImgPhoneHeight) {
					return '1 / 1'
				}


				if (item.preViewImgPhoneWidth != item.preViewImgPhoneHeight) {
					return `${item.preViewImgPhoneWidth} / ${item.preViewImgPhoneHeight}`
				}

			},
			changeCarousel(e) {
				console.log('e', e)
				let imgItem = this.goodsData.product.images[e]
				this.selectImg = imgItem.preview;
				this.selectImgId = imgItem.preview + e
			},
			selectGoodsImg(imgItem, imgIndex) {
				console.log('imgItem', imgItem)
				this.selectImg = imgItem.preview;
				this.selectImgId = imgItem.preview + imgIndex
				this.$refs.carousel.setActiveItem(imgIndex)
			},
			setActiveItem() {

			},
			getObjectFit(e) {
				if (this.layoutConfig.left.percentWidthSwitch) {
					return 'cover'
				} else {
					return 'contain'
				}
			},

			getAffiliateBbjectFit(e) {
				console.log('getAffiliateBbjectFit', this.layoutConfig.left.percentrAffiliateWidthSwitch)
				if (this.layoutConfig.left.percentrAffiliateWidthSwitch) {
					return 'cover'
				} else {
					return 'contain'
				}
			},
			getMaxHeight() {
				return `calc(100% - ${parseInt(this.layoutConfig.left.borderSize[0]) + parseInt(this.layoutConfig.left.borderSize[2]) + 14}px`
			},
			getMainImgMaxWidth() {
				// alert(this.layoutConfig.left.borderSize)
				// if (this.layoutConfig.left.borderSize) {
				// 	return `calc(100% - ${this.layoutConfig.left.borderSize[1] + this.layoutConfig.left.borderSize[3] + 14}px`
				// }


				return `calc(100% - ${parseInt(this.layoutConfig.left.borderSize[1]) + parseInt(this.layoutConfig.left.borderSize[3]) + 14}px`
			},
			getMainImgWidth(type) {

				if (type != 'fill') {
					// if (this.layoutConfig.left.preViewImgWidth - 1 - this.layoutConfig.left.borderSize[1] - this
					// 	.layoutConfig.left.borderSize[3] < 0) {
					// 	return `1px`
					// } else {
					// 	return `${this.layoutConfig.left.preViewImgWidth- 1 - this.layoutConfig.left.borderSize[1] - this.layoutConfig.left.borderSize[3]}px`
					// }
					return `${this.layoutConfig.left.preViewImgWidth- 1}px`
				} else {
					// return '100%'
					return `${this.layoutConfig.left.preViewImgWidth- 1}px`
					// if (this.layoutConfig.left.borderSize && this.layoutConfig.left.detailBorderType && this.layoutConfig
					// 	.left.detailBorderColor) {
					// 		alert(1)
					// 	return `calc(100% - ${parseInt(this.layoutConfig.left.borderSize[1]) +parseInt( this.layoutConfig.left.borderSize[3])}px`
					// }
				}

			},
			getDetailBorder() {
				if (this.layoutConfig.right.detailBorderType && this.layoutConfig.right.detailBorderColor) {
					let style = {}
					style.borderTop =
						`${this.layoutConfig.right.detailBorderType} ${this.layoutConfig.right.detailBorderSize[0]}px ${this.layoutConfig.right.detailBorderColor}`
					style.borderLeft =
						`${this.layoutConfig.right.detailBorderType} ${this.layoutConfig.right.detailBorderSize[1]}px ${this.layoutConfig.right.detailBorderColor}`
					style.borderBottom =
						`${this.layoutConfig.right.detailBorderType} ${this.layoutConfig.right.detailBorderSize[2]}px ${this.layoutConfig.right.detailBorderColor}`
					style.borderRight =
						`${this.layoutConfig.right.detailBorderType} ${this.layoutConfig.right.detailBorderSize[3]}px ${this.layoutConfig.right.detailBorderColor}`
					// console.log('getBorderstyle', style)
					return style
				}
			},
			getBorderRadius() {
				let style = {}
				style.borderRadius =
					`${this.layoutConfig.right.optionBorderRadius[0]}px ${this.layoutConfig.right.optionBorderRadius[1]}px ${this.layoutConfig.right.optionBorderRadius[2]}px ${this.layoutConfig.right.optionBorderRadius[3]}px`
				// console.log('getBorderRadius', style)
				return style
			},
			getBorderSize(item, value, index) {
				// style.borderTop = `${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[0]}px ${this.layoutConfig.left.borderAffiliatedColor}`
				// style.borderLeft = `${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[1]}px ${this.layoutConfig.left.borderAffiliatedColor}`
				// style.borderBottom = `${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[2]}px ${this.layoutConfig.left.borderAffiliatedColor}`
				// style.borderRight = `${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[3]}px ${this.layoutConfig.left.borderAffiliatedColor}`
				let style = {}


				if (this.layoutConfig.right.isHover) {
					if (this.layoutConfig.right.hoverBorderType != '') {
						if (this.enterSizeItem && this.enterSizeItem.name == value.name) {
							style.borderTop =
								`${this.layoutConfig.right.hoverBorderType} ${this.layoutConfig.right.optionBorderSize[0]}px ${this.layoutConfig.right.hoverBorderColor}`
							style.borderLeft =
								`${this.layoutConfig.right.hoverBorderType} ${this.layoutConfig.right.optionBorderSize[1]}px ${this.layoutConfig.right.hoverBorderColor}`
							style.borderBottom =
								`${this.layoutConfig.right.hoverBorderType} ${this.layoutConfig.right.optionBorderSize[2]}px ${this.layoutConfig.right.hoverBorderColor}`
							style.borderRight =
								`${this.layoutConfig.right.hoverBorderType} ${this.layoutConfig.right.optionBorderSize[3]}px ${this.layoutConfig.right.hoverBorderColor}`
							return style

							// return this.layoutConfig.right.hoverBorderType + ' 1px ' + this.layoutConfig.right.hoverBorderColor
						}
					}
				}
				if (this.layoutConfig.right.optionBorderType != '') {
					if (this.select['sku' + index + item.name].name == value.name) {

						style.borderTop =
							`${this.layoutConfig.right.optionBorderType} ${this.layoutConfig.right.optionBorderSize[0]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderLeft =
							`${this.layoutConfig.right.optionBorderType} ${this.layoutConfig.right.optionBorderSize[1]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderBottom =
							`${this.layoutConfig.right.optionBorderType} ${this.layoutConfig.right.optionBorderSize[2]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderRight =
							`${this.layoutConfig.right.optionBorderType} ${this.layoutConfig.right.optionBorderSize[3]}px ${this.layoutConfig.right.optionBorderColor}`
						return style
						// return this.layoutConfig.right.optionBorderType + ' 1px ' + this.layoutConfig.right.optionBorderColor
					} else {
						style.borderTop =
							`dashed ${this.layoutConfig.right.optionBorderSize[0]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderLeft =
							`dashed ${this.layoutConfig.right.optionBorderSize[1]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderBottom =
							`dashed ${this.layoutConfig.right.optionBorderSize[2]}px ${this.layoutConfig.right.optionBorderColor}`
						style.borderRight =
							`dashed ${this.layoutConfig.right.optionBorderSize[3]}px ${this.layoutConfig.right.optionBorderColor}`
						return style
						// return 'dashed 1px ' + this.layoutConfig.right.optionBorderColor
					}
				} else {
					return 'none'
				}
			},
			getAffiliatedBorder(imgItem, imgIndex) {
				if (this.selectImgId == '') {
					// if (this.goodsData.product.images && this.goodsData.product.images.length > 0) {
					// 	this.selectImgId = this.goodsData.product.images[0].preview + 0
					// }

					if (this.goodsData.product.images && this.goodsData.product.images.length > 0 && this.goodsData.product
						.images[0].preview == this.selectImg) {
						this.selectImgId = this.goodsData.product.images[0].preview + 0
					}


				}

				if (this.selectImgId == imgItem.preview + imgIndex) {
					let style = {}
					style.borderTop =
						`${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[0] == 0?1:this.layoutConfig.left.borderAffiliatedSize[0]}px ${this.layoutConfig.left.borderAffiliatedHoverColor}`
					style.borderLeft =
						`${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[1] == 0?1:this.layoutConfig.left.borderAffiliatedSize[1]}px ${this.layoutConfig.left.borderAffiliatedHoverColor}`
					style.borderBottom =
						`${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[2] == 0?1:this.layoutConfig.left.borderAffiliatedSize[2]}px ${this.layoutConfig.left.borderAffiliatedHoverColor}`
					style.borderRight =
						`${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[3] == 0?1:this.layoutConfig.left.borderAffiliatedSize[3]}px ${this.layoutConfig.left.borderAffiliatedHoverColor}`
					return style
				}

				if (this.layoutConfig.left.borderAffiliatedType && this.layoutConfig.left.borderAffiliatedColor) {
					let style = {}
					style.borderTop =
						`${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[0]}px ${this.layoutConfig.left.borderAffiliatedColor}`
					style.borderLeft =
						`${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[1]}px ${this.layoutConfig.left.borderAffiliatedColor}`
					style.borderBottom =
						`${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[2]}px ${this.layoutConfig.left.borderAffiliatedColor}`
					style.borderRight =
						`${this.layoutConfig.left.borderAffiliatedType} ${this.layoutConfig.left.borderAffiliatedSize[3]}px ${this.layoutConfig.left.borderAffiliatedColor}`
					console.log('getBorderstyle', style)
					return style
				}
			},
			getAffiliatedBoderRadius() {
				let style = {}
				style.borderRadius =
					`${this.layoutConfig.left.borderAffiliatedRadius[0]}px ${this.layoutConfig.left.borderAffiliatedRadius[1]}px ${this.layoutConfig.left.borderAffiliatedRadius[2]}px ${this.layoutConfig.left.borderAffiliatedRadius[3]}px`
				return style
			},
			getBoderRadius() {
				let style = {}
				style.borderRadius =
					`${this.layoutConfig.left.borderRadius[0]}px ${this.layoutConfig.left.borderRadius[1]}px ${this.layoutConfig.left.borderRadius[2]}px ${this.layoutConfig.left.borderRadius[3]}px`
				return style
			},
			getBorder() {
				if (this.layoutConfig.left.borderType && this.layoutConfig.left.borderColor) {
					let style = {}
					style.borderTop =
						`${this.layoutConfig.left.borderType} ${this.layoutConfig.left.borderSize[0]}px ${this.layoutConfig.left.borderColor}`
					style.borderLeft =
						`${this.layoutConfig.left.borderType} ${this.layoutConfig.left.borderSize[1]}px ${this.layoutConfig.left.borderColor}`
					style.borderBottom =
						`${this.layoutConfig.left.borderType} ${this.layoutConfig.left.borderSize[2]}px ${this.layoutConfig.left.borderColor}`
					style.borderRight =
						`${this.layoutConfig.left.borderType} ${this.layoutConfig.left.borderSize[3]}px ${this.layoutConfig.left.borderColor}`
					console.log('getBorderstyle', style)
					return style
				}
			},
			async buyNow() {
				try {
					if (this.type == 'design') {
						return
					}
					console.log(this.sku)
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					
					let obj = {}
					if(this.selectOptions.length > 0){
						obj.options = []
						this.selectOptions.forEach(item=>{
							obj.options.push(item.value.id)
						})
					}
						
					
					await getAccountAddCarts({
						wsid,
						buy_now: true,
						sku_id: this.sku.id,
						quantity: this.order.num,
						...obj
					})
					
					facebookPixel.track('InitiateCheckout');
					this.$router.push({
						path: '/checkout'
					})
					this.loading = false
				} catch (e) {
					console.log('e', e)
					// this.$message.error(e.response.data.message)
					this.loading = false
				}
			},
			async addCarts() {
				try {
					console.log('addCartsaddCarts', this.sku)
					if (this.type == 'design') {
						return
					}
					let obj = {}
					if(this.selectOptions.length > 0){
						obj.options = []
						this.selectOptions.forEach(item=>{
							obj.options.push(item.value.id)
						})
					}
						
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await getAccountAddCarts({
						wsid,
						buy_now: false,
						...obj,
						sku_id: this.sku.id,
						quantity: this.order.num,
						
					})
					
					 facebookPixel.track('AddToCart');

					this.setList({
						filed: "cartNum",
						list: parseInt(this.order.num) + parseInt(this.cartNum),
					})

					console.log('this.cartNum', this.cartNum)


					this.$message.success(data.data.message)
					this.loading = false
				} catch (e) {
					console.log('e', e)
					// this.$message.error(e.response.data.message)
					this.loading = false
				}
			},
			async collect() {
				try {
					if (this.type == 'design') {
						return
					}
					console.log(this.sku)
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await getAccountCollect({
						wsid,
						product_id: this.goodsData.product.id
					})
					facebookPixel.track('AddTowishlist',{
						eventID: 'unique_event_id_' + Date.now() // 使用时间戳或其他唯一ID
					});
					console.log(data)
					this.$message.success(data.data.message)
					this.loading = false
					this.isCollct = !this.isCollct
				} catch (e) {
					if (e.status == 401) {
						this.dialogVisible = true
						this.iframeLogin = true
					}
					console.log('e', e)
					this.loading = false
				}


			},
			getBgStyle(e) {
				if (e.bgType == '1') {
					return {
						backgroundColor: e.singleBgColor
					}
				}
				if (e.bgType == '2') {
					return e.bgColor
				}
				if (e.bgType == '3') {
					let style = {}
					let backgroundImage = `url(${e.bgImg})`

					if (e.bgWidth) {
						style.backgroundSize = e.bgWidth + 'px';
					} else {
						style.backgroundSize = '100%';
					}
					if (e.bgHeight) {
						style.backgroundSize = style.backgroundSize + ' ' + (e.bgHeight +
							'px')
					} else {
						style.backgroundSize = style.backgroundSize + ' 100%'
					}
					if (e.bgImgType) {
						style.backgroundRepeat = e.bgImgType
					}
					if (e.bgPosition) {
						style.backgroundPosition = e.bgPosition
					}
					style.backgroundImage = backgroundImage
					return style
				}
			},
			changeIpt() {
				if (this.order.num > this.sku.quantity) {
					this.order.num = this.sku.quantity
				}
				if (this.order.num == 0) {
					this.order.num = 1
				}
			},
			add() {
				this.order.num = this.order.num + 1
				if (this.order.num > this.sku.quantity) {
					this.order.num = this.sku.quantity
				}
			},
			sub() {
				if (this.order.num == 0) {
					return
				}
				this.order.num = this.order.num - 1
				if (this.order.num <= 0) {
					this.order.num = 1
				}
			},
			handleChange(e) {

			},
			hexToRgb(str) {
				let hexs = null;
				let reg = /^\#?[0-9A-Fa-f]{6}$/;
				if (!reg.test(str)) return alert('色值不正确')
				str = str.replace('#', '') // 去掉#
				hexs = str.match(/../g) // 切割成数组 409EFF => ['40','9E','FF']
				// 将切割的色值转换为16进制
				for (let i = 0; i < hexs.length; i++) hexs[i] = parseInt(hexs[i], 16)
				return hexs // 返回rgb色值[64, 158, 255]
			},
			getLightColor(hexColor, percent = 20) {
				// 移除#号（如果存在）
				let hex = hexColor.replace(/^#/, '');

				// 如果是3位简写，转换为6位
				if (hex.length === 3) {
					hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
				}

				// 转换为RGB
				const r = parseInt(hex.substring(0, 2), 16);
				const g = parseInt(hex.substring(2, 4), 16);
				const b = parseInt(hex.substring(4, 6), 16);

				// 计算变淡后的RGB值
				const lighten = (color) => Math.min(255, color + (255 - color) * (percent / 100));

				const newR = lighten(r);
				const newG = lighten(g);
				const newB = lighten(b);

				// 转换回16进制
				const toHex = (color) => {
					const hex = Math.round(color).toString(16);
					return hex.length === 1 ? '0' + hex : hex;
				};

				return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
			},
			selectValue(item, value, valueIndex, index) {
				console.log('item', item)
				console.log('value', value)
				this.select['sku' + index + item.name] = {
					...value
				}
				this.select['sku' + index + item.name].index = valueIndex
				this.selectIndexs = []
				for (let i in this.select) {
					this.selectIndexs.push(this.select[i].index)
				}
				console.log('this.select', this.select)
				console.log('this.selectIndexs', this.selectIndexs.join(''))
				console.log('this.selectIndexs', this.select)

				this.goodsData.product.skus.forEach(item => {
					if (item.variants.join('') == this.selectIndexs.join('')) {
						this.sku = item
						console.log('this.skuthis.skuthis.sku', this.sku)

						// 切换图片
						if (item.images.length > 0) {
							this.selectImg = item.images[0].preview
							let esixt = false
							this.goodsData.product.images.forEach((imgItem, imgIndex) => {
								if (imgItem.preview == item.images[0].preview) {
									esixt = true

									this.selectImgId = imgItem.preview + imgIndex
									if (this.equipment == 'phone') {
										this.selectGoodsImg(imgItem, imgIndex)
									}
								}
							})
							if (!esixt) {
								this.selectImgId = item.images[0].preview + 0
								this.goodsData.product.images.unshift(item.images[0])
								if (this.equipment == 'phone') {
									this.selectGoodsImg(item, 0)
								}
							}
							this.$forceUpdate()
						}
					}
				})

				this.$forceUpdate()
			},
			handleMouseEnter() {
				this.isHovered = true;
			},
			handleMouseLeave() {
				this.isHovered = false;
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-form-item__label {
		color: var(--formLabelColor);

	}

	::v-deep .bto {
		::v-deep .el-input-number:hover {
			border: 1px #000 solid;
		}

		// .el-inputmumber increase:hover:not(.is-disabled)~.el-input .el-input inner:not(.is-disabled) {
		// 	border: 1px #000 solid;
		// }
		// .el-input-number--medium:hover {
		// 	border: 1px #000 solid;
		// }
		// .el-input--medium:hover {
		// 	border: 1px #000 solid;
		// }
	}

	.add-cart:active {
		background-color: #000;
		color: #ffffff;
	}

	::v-deep .el-input__inner:focus {
		border: 0px #ffffff solid;
	}

	/* 移除悬停加号按钮时输入框的边框颜色变化 */
	::v-deep .el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
		border: 1px #d6d6d6 solid;
		/* 或者直接使用透明色 */
		/* border-color: transparent !important; */
	}

	/* 如果需要也可以同时处理减号按钮 */
	::v-deep .el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
		border: 1px #d6d6d6 solid;
	}

	::v-deep .el-input-number__increase {
		.el-icon-plus:hover {
			color: '#000' !important
		}

		color:'#000' !important
	}

	::v-deep .el-input-number__decrease:hover {
		color: '#000' !important
	}



	// 折叠面板
	::v-deep.el-collapse {
		background-color: var(--bgColor) !important;
	}

	::v-deep.el-collapse,
	.el-collapse-item__wrap {
		border: none;
		background-color: var(--bgColor) !important;
	}

	::v-deep .el-collapse-item__header {
		font-size: var(--collapseFontSize) !important;
	}

	::v-deep .el-collapse-item__header {
		color: var(--fontColor);
		background-color: var(--bgColor) !important;
	}

	::v-deep .el-collapse-item__content {
		color: var(--fontColor);
		background-color: var(--bgColor) !important;
	}


	::v-deep .el-pager {

		.active {
			color: var(--selectColor);
		}

		li:hover {
			color: var(--hoverColor);
		}

		li {
			background-color: rgb(0 0 0 / 0%);
		}
	}

	::v-deep .el-pagination {
		.btn-prev {
			background-color: rgb(0 0 0 / 0%);
		}

		.btn-next {
			background-color: rgb(0 0 0 / 0%);
		}

		button:hover {
			color: var(--hoverColor);
		}
	}
</style>